

// import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import parties from '../data/party';
// import stockdata from '../data/stock';
// import sellstocks from '../data/sellstocks';
// import settingapi from '../data/setting';
// import OcrUploadModal from './OcrUploadModal';

// interface Party {
//   id: number;
//   name: string;
//   total_amount?: number | string;
// }

// type SellStockRecord = {
//   id: number;
//   party_id: number;
//   category: string;
//   stock_id: string;
//   stock_name: string;
//   sell_units: string;
//   sell_amount: string;
//   indirect_charges: string;
//   date: string;
//   catrgories?: string;
// };

// interface StockDBCategoryItem {
//   id: number | string;
//   investment_type: string;
//   category: string;
//   stock_name: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
// }

// // Deduplicated stock with merged units/amounts across DB rows
// interface MergedStockItem {
//   stock_name: string;
//   category: string;
//   unit: string;          // sum of remaining units across all rows
//   total_amount: string;  // sum of total_amount across all rows
//   indirect_charges: string;
//   perUnitCharge: string; // weighted average
//   investment_type: string;
//   // Keep ids of all source rows for reference
//   sourceIds: (number | string)[];
// }

// type SellStockFormState = {
//   partyId: string;
//   category: string;
//   stockId: string | number;
//   stockName: string;
//   sellUnits: string;
//   sellAmount: string;
//   indirectCharges: string;
//   date: string;
// };

// const PRIMARY = '#17946B';
// const SECONDARY = '#FF9500';

// async function fetchSellStocks(): Promise<SellStockRecord[]> {
//   try {
//     const res = await sellstocks();
//     if (res && typeof res.json === 'function') {
//       if (!res.ok) return [];
//       const data = await res.json();
//       return Array.isArray(data) ? data : [];
//     } else if (Array.isArray(res)) {
//       return res;
//     }
//     return [];
//   } catch {
//     return [];
//   }
// }

// function getSellUnitsForStock(
//   sellStocks: SellStockRecord[],
//   partyId: string,
//   category: string,
//   stockName: string
// ): number {
//   return sellStocks.reduce((sum, rec) => {
//     if (
//       String(rec.party_id) === String(partyId) &&
//       String(rec.category) === String(category) &&
//       String(rec.stock_id) === String(stockName)
//     ) {
//       return sum + parseFloat(rec.sell_units || '0');
//     }
//     return sum;
//   }, 0);
// }

// function getPartyStocksAdjusted(
//   stocksDbRows: any[],
//   sellStocks: SellStockRecord[],
//   partyId: string
// ) {
//   let result: { [category: string]: StockDBCategoryItem[] } = {};
//   for (const row of stocksDbRows) {
//     if (String(row.party_id) !== String(partyId)) continue;
//     let catsArr: StockDBCategoryItem[] = [];
//     if (typeof row.categories === 'string') {
//       try {
//         const parsed = JSON.parse(row.categories);
//         catsArr = Array.isArray(parsed) ? parsed : [];
//       } catch {
//         catsArr = [];
//       }
//     } else if (Array.isArray(row.categories)) {
//       catsArr = row.categories as StockDBCategoryItem[];
//     }
//     for (const item of catsArr) {
//       const soldUnits = getSellUnitsForStock(
//         sellStocks,
//         partyId,
//         item.category,
//         item.stock_name
//       );
//       let origUnit = parseFloat(item.unit || '0');
//       let remainingUnit = origUnit - soldUnits;
//       const adjustedItem = {
//         ...item,
//         unit: remainingUnit >= 0 ? String(remainingUnit) : '0',
//       };
//       if (!result[item.category]) result[item.category] = [];
//       result[item.category].push(adjustedItem);
//     }
//   }
//   return result;
// }

// /**
//  * Merges duplicate stock entries (same stock_name + category) across multiple
//  * DB rows into a single item, summing units and amounts, computing weighted avg
//  * perUnitCharge, and dropping entries with 0 remaining units.
//  */
// function mergeStocksByName(items: StockDBCategoryItem[]): MergedStockItem[] {
//   const map = new Map<string, MergedStockItem>();

//   for (const item of items) {
//     const key = `${item.category}__${item.stock_name}`;
//     const unit = parseFloat(item.unit || '0');
//     const totalAmount = parseFloat(item.total_amount || '0');
//     const indirectCharges = parseFloat(item.indirect_charges || '0');

//     if (map.has(key)) {
//       const existing = map.get(key)!;
//       const newUnit = parseFloat(existing.unit) + unit;
//       const newTotal = parseFloat(existing.total_amount) + totalAmount;
//       const newIndirect = parseFloat(existing.indirect_charges) + indirectCharges;
//       const newPerUnit = newUnit > 0 ? ((newTotal + newIndirect) / newUnit).toFixed(2) : '0.00';

//       map.set(key, {
//         ...existing,
//         unit: String(newUnit),
//         total_amount: String(newTotal),
//         indirect_charges: String(newIndirect),
//         perUnitCharge: newPerUnit,
//         sourceIds: [...existing.sourceIds, item.id],
//       });
//     } else {
//       map.set(key, {
//         stock_name: item.stock_name,
//         category: item.category,
//         unit: String(unit),
//         total_amount: String(totalAmount),
//         indirect_charges: String(indirectCharges),
//         perUnitCharge: item.perUnitCharge || (unit > 0 ? ((totalAmount + indirectCharges) / unit).toFixed(2) : '0.00'),
//         investment_type: item.investment_type,
//         sourceIds: [item.id],
//       });
//     }
//   }

//   // Filter out stocks with 0 remaining units
//   return Array.from(map.values()).filter(
//     s => !!(s.stock_name && s.stock_name.trim()) && parseFloat(s.unit) > 0
//   );
// }

// function safeNumber(v: any): number {
//   const n = parseFloat(String(v));
//   return isNaN(n) ? 0 : n;
// }

// const SellStocksPage = () => {
//   const [partiesList, setPartiesList] = useState<Party[]>([]);
//   const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);
//   const [stocksDataDb, setStocksDataDb] = useState<any[]>([]);
//   const [totalamountspend, setTotalAmmountSpend] = useState<Number>();
//   const [showOcrModal, setShowOcrModal] = useState(false);
//   const [farmName, setFarmName] = useState<string>();

//   const [sellStockForm, setSellStockForm] = useState<SellStockFormState>({
//     partyId: '',
//     category: '',
//     stockId: '',
//     stockName: '',
//     sellUnits: '',
//     sellAmount: '',
//     indirectCharges: '',
//     date: '',
//   });
//   const [autoAmount, setAutoAmount] = useState<number>(0);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     async function fetchSettingsApi() {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const farmSetting = res.find((item: any) => item.meta_key === 'farm');
//           if (farmSetting && farmSetting.meta_value !== undefined) {
//             let farmObj = {};
//             try {
//               farmObj =
//                 typeof farmSetting.meta_value === 'string'
//                   ? JSON.parse(farmSetting.meta_value)
//                   : farmSetting.meta_value;
//             } catch {}
//             if (
//               farmObj &&
//               typeof farmObj === 'object' &&
//               farmObj !== null &&
//               'name' in farmObj &&
//               typeof (farmObj as { name?: unknown }).name === 'string'
//             ) {
//               setFarmName((farmObj as { name: string }).name);
//             }
//           }
//         }
//       } catch {}
//     }
//     fetchSettingsApi();
//   }, []);

//   useEffect(() => {
//     async function loadSellStocks() {
//       const sellArr = await fetchSellStocks();
//       setSellStocks(sellArr);
//     }
//     loadSellStocks();
//   }, []);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     setSellStockForm((s) => ({ ...s, partyId }));
//   }, []);

//   useEffect(() => {
//     (async () => {
//       const pts = await parties();
//       setPartiesList(Array.isArray(pts) ? pts : []);
//       const db = await stockdata();
//       setStocksDataDb(Array.isArray(db) ? db : []);
//     })();
//   }, []);

//   async function fetchParties() {
//     const pts = await parties();
//     setPartiesList(Array.isArray(pts) ? pts : []);
//   }

//   // Raw (unadjusted) stocks by category for the selected party
//   const partyStocksByCat = useMemo(
//     () => getPartyStocksAdjusted(stocksDataDb, sellStocks, sellStockForm.partyId),
//     [stocksDataDb, sellStocks, sellStockForm.partyId]
//   );

//   const partyCategories = useMemo(() => Object.keys(partyStocksByCat), [partyStocksByCat]);

//   // Raw items for the selected category (may have duplicates)
//   const rawStocksInCategory = useMemo(
//     () =>
//       sellStockForm.category ? partyStocksByCat[sellStockForm.category] || [] : [],
//     [sellStockForm.category, partyStocksByCat]
//   );

//   // Deduplicated, merged stocks — one entry per unique stock_name with 0-unit entries removed
//   const stocksInCurrentCategory = useMemo(
//     () => mergeStocksByName(rawStocksInCategory),
//     [rawStocksInCategory]
//   );

//   // The selected merged stock object
//   const selectedStockObj = useMemo(
//     () =>
//       stocksInCurrentCategory.find(
//         (s) => String(s.stock_name) === String(sellStockForm.stockName)
//       ),
//     [sellStockForm.stockName, stocksInCurrentCategory]
//   );

//   useEffect(() => {
//     const unitsNum = parseFloat(sellStockForm.sellUnits || '0');
//     if (!selectedStockObj || isNaN(unitsNum) || unitsNum <= 0) {
//       setAutoAmount(0);
//       return;
//     }
//     const totalAvailableUnits = parseFloat(selectedStockObj.unit);
//     const amount = parseFloat(selectedStockObj.total_amount);
//     const amt = totalAvailableUnits > 0 ? (amount / totalAvailableUnits) * unitsNum : 0;
//     setAutoAmount(amt);
//   }, [sellStockForm.sellUnits, selectedStockObj]);

//   const fetchUserRemainingBalance = useCallback(
//     async (partyId: string) => {
//       if (!partyId) {
//         setTotalAmmountSpend(0);
//         return;
//       }
//       try {
//         const usermetaResponse = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/updateusermeta`
//         );
//         const usermetaList = await usermetaResponse.json();
//         const foundMeta = usermetaList.find(
//           (meta: any) =>
//             meta.meta_key === 'remaining' && String(meta.party_id) === String(partyId)
//         );
//         if (foundMeta) {
//           setTotalAmmountSpend(Number(foundMeta.meta_value));
//         } else {
//           const party = partiesList.find((p) => String(p.id) === String(partyId));
//           setTotalAmmountSpend(Number(party?.total_amount || 0));
//         }
//       } catch (err) {
//         console.error('Error fetching usermeta:', err);
//         setTotalAmmountSpend(0);
//       }
//     },
//     [partiesList]
//   );

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     fetchUserRemainingBalance(partyId);
//   }, [fetchUserRemainingBalance]);

//   // --- UI EVENT HANDLERS ---
//   const handleFormChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
//   ) => {
//     const { name, value } = e.target;

//     if (name === 'sellUnits') {
//       if (selectedStockObj) {
//         const maxUnits = parseFloat(selectedStockObj.unit || '0');
//         if (value === '' || value === undefined) {
//           setSellStockForm((s) => ({ ...s, sellUnits: '' }));
//           return;
//         }
//         const entered = parseFloat(value);
//         if (isNaN(entered) || entered < 0) return;
//         if (entered > maxUnits) {
//           setSellStockForm((s) => ({ ...s, sellUnits: maxUnits.toString() }));
//           return;
//         }
//         setSellStockForm((s) => ({ ...s, sellUnits: value }));
//         return;
//       }
//     }

//     if (name === 'sellAmount') {
//       if (selectedStockObj) {
//         if (value === '' || value === undefined) {
//           setSellStockForm((s) => ({ ...s, sellAmount: '' }));
//           return;
//         }
//         const entered = parseFloat(value);
//         if (isNaN(entered) || entered < 0) return;
//         setSellStockForm((s) => ({ ...s, sellAmount: value }));
//         return;
//       }
//     }

//     let patch: Partial<SellStockFormState> = { [name]: value };
//     if (name === 'partyId') {
//       patch.category = '';
//       patch.stockId = '';
//       patch.stockName = '';
//       patch.sellUnits = '';
//       patch.sellAmount = '';
//       patch.date = '';
//     }
//     if (name === 'category') {
//       patch.stockId = '';
//       patch.stockName = '';
//       patch.sellUnits = '';
//       patch.sellAmount = '';
//     }
//     if (name === 'stockId') {
//       // value is stock_name (used as the option value)
//       const found = stocksInCurrentCategory.find(
//         (s) => String(s.stock_name) === value
//       );
//       patch.stockName = found ? found.stock_name : '';
//       patch.stockId = found ? found.stock_name : '';
//     }
//     setSellStockForm((s) => ({ ...s, ...patch }));
//   };

//   // ─── OCR submit — mirrors handleSellStockSubmit for sell flow ───────────────
//   // NOTE: OcrUploadModal batches are purchase records (buy flow).
//   // This handler processes each OCR batch row as a SELL transaction,
//   // matching the same invoice / buysellrecord / usermeta pattern used in
//   // handleSellStockSubmit.
//   const handleOcrSubmit = async ({
//     partyId,
//     category,
//     batches,
//   }: {
//     partyId: string;
//     category: string;
//     batches: { date: string; rows: any[] }[];
//   }): Promise<void> => {
//     if (!partyId) { alert('Please select a party'); return; }
//     if (!category) { alert('Please select a category'); return; }

//     for (const batch of batches) {
//       if (!batch.date) continue;
//       const validRows = batch.rows.filter((r: any) => r.stock_name?.trim());
//       if (!validRows.length) continue;

//       for (const row of validRows) {
//         // Resolve the merged stock to get accurate available units & per-unit price
//         const mergedStock = stocksInCurrentCategory.find(
//           (s) => s.stock_name === row.stock_name && s.category === category
//         );

//         const sellUnitsNumber = safeNumber(row.sell_units ?? row.unit);
//         if (!sellUnitsNumber || sellUnitsNumber <= 0) continue;

//         if (mergedStock) {
//           const available = parseFloat(mergedStock.unit);
//           if (sellUnitsNumber > available) {
//             alert(
//               `Not enough units for "${row.stock_name}". ` +
//               `Available: ${available}, Requested: ${sellUnitsNumber}`
//             );
//             continue;
//           }
//         }

//         // Determine sell amount — prefer explicit value, else auto-calculate
//         let sellAmount = safeNumber(row.sell_amount ?? row.total_amount);
//         if (!sellAmount && mergedStock) {
//           const availableUnits = parseFloat(mergedStock.unit);
//           const totalAmt = parseFloat(mergedStock.total_amount);
//           sellAmount =
//             availableUnits > 0 ? (totalAmt / availableUnits) * sellUnitsNumber : 0;
//         }

//         const indirectCharges = safeNumber(row.indirect_charges ?? 0);
//         const netSale = sellAmount - indirectCharges;

//         // 1) Main sellstocks record
//         try {
//           const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               party_id: partyId,
//               category,
//               stock_id: row.stock_name,    // stock_id stored as name, same as handleSellStockSubmit
//               stock_name: row.stock_name,
//               sell_units: sellUnitsNumber,
//               sell_amount: sellAmount,
//               indirect_charges: indirectCharges,
//               date: batch.date,
//             }),
//           });
//           if (!res.ok) {
//             console.error('sellstocks POST failed for', row.stock_name);
//             continue;
//           }
//         } catch (err) {
//           console.error('sellstocks POST error', err);
//           continue;
//         }

//         // 2) Invoice record — sell type, mirrors handleSellStockSubmit exactly
//         try {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               farm: farmName,
//               party: partyId,
//               invoice_type: 'sell',
//               date: batch.date,
//               datainvoice: JSON.stringify([
//                 {
//                   stock_id: row.stock_name,
//                   stock_name: row.stock_name,
//                   category,
//                   sell_units: sellUnitsNumber,
//                   sell_amount: sellAmount,
//                   indirect_charges: indirectCharges,
//                   total_amount: sellAmount,
//                   date: batch.date,
//                 },
//               ]),
//             }),
//           });
//         } catch (err) {
//           console.error('Invoice POST error', err);
//         }

//         // 3) buysellrecord — mirrors handleSellStockSubmit logic
//         try {
//           let perUnitPrice = 0;
//           if (mergedStock) {
//             perUnitPrice = safeNumber(mergedStock.perUnitCharge);
//             if (!perUnitPrice) {
//               const totalAmountVal = parseFloat(mergedStock.total_amount) || 0;
//               // restore sold units to approximate original total
//               const totalUnitsVal = parseFloat(mergedStock.unit) + sellUnitsNumber;
//               perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
//             }
//           }
//           const totalpurchase = sellUnitsNumber * perUnitPrice;
//           const totalsell = netSale;

//           const latestRes = await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
//           );
//           const latestList = await latestRes.json();
//           const latestEntry =
//             Array.isArray(latestList) && latestList.length > 0
//               ? latestList[latestList.length - 1]
//               : null;

//           if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
//             const prevTotalSell = safeNumber(latestEntry.totalsell);
//             const newTotalSell = prevTotalSell + totalsell;
//             const newClosingBLC = safeNumber(latestEntry.totalpurchase) - newTotalSell;

//             await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//               method: 'PUT',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 id: latestEntry.id,
//                 date: batch.date,
//                 totalpurchase: latestEntry.totalpurchase,
//                 totalsell: newTotalSell,
//                 closingBLC: newClosingBLC,
//               }),
//             });
//           } else {
//             await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 date: batch.date,
//                 totalpurchase,
//                 totalsell,
//                 closingBLC: 0 - totalpurchase + totalsell,
//               }),
//             });
//           }
//         } catch (err) {
//           console.error('buysellrecord error', err);
//         }

//         // 4) usermeta "remaining" — mirrors handleSellStockSubmit handleUserMetaUpdate
//         try {
//           const umRes = await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`
//           );
//           const umList = await umRes.json();
//           const foundMeta = Array.isArray(umList)
//             ? umList.find(
//                 (m: any) =>
//                   m.meta_key === 'remaining' && String(m.party_id) === String(partyId)
//               )
//             : null;

//           if (foundMeta) {
//             const oldVal = safeNumber(foundMeta.meta_value);
//             await fetch(
//               `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
//               {
//                 method: 'PUT',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   meta_key: 'remaining',
//                   meta_value: (oldVal + netSale).toString(),
//                   party_id: partyId,
//                 }),
//               }
//             );
//           } else {
//             const party = partiesList.find((p) => String(p.id) === String(partyId));
//             const baseAmount = safeNumber(party?.total_amount ?? 0);
//             await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 meta_key: 'remaining',
//                 meta_value: (baseAmount + netSale).toString(),
//                 party_id: partyId,
//               }),
//             });
//           }

//           // Keep local state in sync
//           setTotalAmmountSpend((prev) => (safeNumber(prev) || 0) + netSale);
//         } catch (err) {
//           console.error('usermeta error', err);
//         }
//       }
//     }

//     await fetchParties();
//     // Refresh sell stocks so UI reflects new sales
//     const sellArr = await fetchSellStocks();
//     setSellStocks(sellArr);
//     setShowOcrModal(false);
//   };

//   const handleSellStockSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!sellStockForm.partyId) return alert('Select party');
//     if (!sellStockForm.category) return alert('Select category');
//     if (!sellStockForm.stockId) return alert('Select stock');
//     const sellUnitsNumber = parseFloat(sellStockForm.sellUnits || '0');
//     if (!sellUnitsNumber || isNaN(sellUnitsNumber) || sellUnitsNumber <= 0)
//       return alert('Please enter valid units to sell');
//     if (!selectedStockObj) return alert('Select valid stock');
//     if (sellUnitsNumber > parseFloat(selectedStockObj.unit || '0')) {
//       return alert(
//         `Not enough units available to sell! Available: ${selectedStockObj.unit}, Requested: ${sellUnitsNumber}`
//       );
//     }
//     if (!sellStockForm.date) return alert('Select date for sell');

//     const sellAmount =
//       Number(sellStockForm.sellAmount) > 0
//         ? Number(sellStockForm.sellAmount)
//         : typeof autoAmount !== 'undefined'
//         ? Number(autoAmount)
//         : 0;
//     const indirectCharges = Number(sellStockForm.indirectCharges) || 0;
//     const netSale = sellAmount - indirectCharges;

//     const handleUserMetaUpdate = async () => {
//       try {
//         const usermetaResponse = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${sellStockForm.partyId}`
//         );
//         const usermetaList = await usermetaResponse.json();
//         const foundMeta = Array.isArray(usermetaList)
//           ? usermetaList.find(
//               (meta: any) =>
//                 meta.meta_key === 'remaining' &&
//                 String(meta.party_id) === String(sellStockForm.partyId)
//             )
//           : undefined;

//         if (foundMeta) {
//           const oldVal = parseFloat(foundMeta.meta_value || '0');
//           const meta_value = (oldVal + netSale).toString();
//           await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
//             {
//               method: 'PUT',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 meta_key: 'remaining',
//                 meta_value,
//                 party_id: sellStockForm.partyId,
//               }),
//             }
//           );
//         } else {
//           const oldVal = Number(totalamountspend) || 0;
//           const remaining = (oldVal + netSale).toString();
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: remaining,
//               party_id: sellStockForm.partyId,
//             }),
//           });
//         }
//       } catch (err) {
//         console.error('Usermeta API failed', err);
//       }
//     };

//     setLoading(true);
//     try {
//       const payload = {
//         party_id: sellStockForm.partyId,
//         category: sellStockForm.category,
//         stock_id: sellStockForm.stockId,
//         stock_name: sellStockForm.stockName,
//         sell_units: sellUnitsNumber,
//         sell_amount: sellAmount,
//         indirect_charges: sellStockForm.indirectCharges,
//         date: sellStockForm.date,
//       };

//       const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });
//       const result = await res.json();
//       if (!res.ok) throw new Error(result?.message || 'Failed to sell stock');

//       // Invoice
//       try {
//         const invoiceData = {
//           farm: farmName,
//           party: sellStockForm.partyId,
//           invoice_type: 'sell',
//           date: sellStockForm.date,
//           datainvoice: JSON.stringify([
//             {
//               stock_id: sellStockForm.stockId,
//               stock_name: sellStockForm.stockName,
//               category: sellStockForm.category,
//               sell_units: sellUnitsNumber,
//               sell_amount: sellAmount,
//               indirect_charges: sellStockForm.indirectCharges,
//               total_amount: sellAmount,
//               date: sellStockForm.date,
//             },
//           ]),
//         };
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(invoiceData),
//         });
//       } catch (err) {
//         console.error('Error adding sell invoice:', err);
//       }

//       // buysellrecord
//       try {
//         let perUnitPrice = 0;
//         if (selectedStockObj) {
//           perUnitPrice = Number(selectedStockObj.perUnitCharge);
//           if (!perUnitPrice || isNaN(perUnitPrice)) {
//             const totalAmountVal = parseFloat(selectedStockObj.total_amount) || 0;
//             const totalUnitsVal = parseFloat(selectedStockObj.unit) + sellUnitsNumber;
//             perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
//           }
//         }
//         const totalpurchase = sellUnitsNumber * perUnitPrice;
//         const totalsell = netSale;

//         const latestRes = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
//         );
//         const latestList = await latestRes.json();
//         const latestEntry =
//           Array.isArray(latestList) && latestList.length > 0
//             ? latestList[latestList.length - 1]
//             : null;

//         if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
//           const prevTotalSell = Number(latestEntry.totalsell) || 0;
//           const newTotalSell = prevTotalSell + totalsell;
//           const newClosingBLC =
//             (Number(latestEntry.totalpurchase) || 0) - newTotalSell;

//           await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: latestEntry.id,
//               date: sellStockForm.date,
//               totalpurchase: latestEntry.totalpurchase,
//               totalsell: newTotalSell,
//               closingBLC: newClosingBLC,
//             }),
//           });
//         } else {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               date: sellStockForm.date,
//               totalpurchase,
//               totalsell,
//               closingBLC: 0 - totalpurchase + totalsell,
//             }),
//           });
//         }
//       } catch (err) {
//         console.error('Failed to send buysellrecord', err);
//       }

//       setTotalAmmountSpend((prev) => (Number(prev) || 0) + netSale);
//       await handleUserMetaUpdate();

//       alert('Stock sell recorded successfully!');
//       setSellStockForm({
//         partyId: sellStockForm.partyId,
//         category: '',
//         stockId: '',
//         stockName: '',
//         sellUnits: '',
//         sellAmount: '',
//         indirectCharges: '',
//         date: '',
//       });
//       window.location.reload();
//     } catch (err: any) {
//       alert('Error: ' + (err?.message ?? 'Something went wrong'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   // OcrUploadModal reads `p?.categories` from each party to build its Category dropdown.
//   // Our Party type doesn't include categories, so we enrich the list here from stocksDataDb.
//   const partiesListWithCategories = useMemo(() => {
//     return partiesList.map(party => {
//       const cats = new Set<string>();
//       for (const row of stocksDataDb) {
//         if (String(row.party_id) !== String(party.id)) continue;
//         let arr: any[] = [];
//         try {
//           arr = typeof row.categories === 'string'
//             ? JSON.parse(row.categories)
//             : Array.isArray(row.categories) ? row.categories : [];
//         } catch { arr = []; }
//         for (const item of arr) {
//           if (item?.category) cats.add(item.category);
//         }
//       }
//       return { ...party, categories: Array.from(cats) };
//     });
//   }, [partiesList, stocksDataDb]);

//   // OcrUploadModal expects { id: number; name: string }[] for stocksnames / mutualsnames.
//   // Build from ALL rows in stocksDataDb (not just selected party) so the modal's
//   // react-select dropdown has the full list regardless of which party is picked.
//   //   - mutualsnames → categories containing "mutual" (case-insensitive)
//   //   - stocksnames  → everything else
//   const { stocksnames, mutualsnames } = useMemo(() => {
//     const stocksSet = new Map<string, { id: number; name: string }>();
//     const mutualsSet = new Map<string, { id: number; name: string }>();
//     let counter = 1;

//     for (const row of stocksDataDb) {
//       let arr: StockDBCategoryItem[] = [];
//       try {
//         arr = typeof row.categories === 'string'
//           ? JSON.parse(row.categories)
//           : Array.isArray(row.categories) ? row.categories : [];
//       } catch { arr = []; }

//       for (const item of arr) {
//         if (!item?.stock_name?.trim()) continue;
//         const isMutual = item.category?.toLowerCase().includes('mutual');
//         const target = isMutual ? mutualsSet : stocksSet;
//         if (!target.has(item.stock_name)) {
//           target.set(item.stock_name, { id: counter++, name: item.stock_name });
//         }
//       }
//     }

//     return {
//       stocksnames: Array.from(stocksSet.values()),
//       mutualsnames: Array.from(mutualsSet.values()),
//     };
//   }, [stocksDataDb]);

//   // ------------ UI ---------------
//   return (
//     <div className="w-full min-h-[80vh] flex flex-col items-center justify-center bg-gradient-to-br from-[#f6fcf8] to-[#fff8ef] py-10 transition-colors">
//       <div className="w-full max-w-2xl bg-white shadow-2xl rounded-3xl px-6 sm:px-12 py-10 border-4 border-[color:var(--primary)]/10 relative overflow-hidden duo-form-glow">
//         <div className="hidden absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-t-3xl animate-fadein" />

//         <button
//           type="button"
//           onClick={() => setShowOcrModal(true)}
//           className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
//         >
//           <svg
//             className="w-5 h-5 text-white"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth={2}
//             viewBox="0 0 24 24"
//           >
//             <rect
//               x="3"
//               y="4"
//               width="18"
//               height="16"
//               rx="2"
//               stroke="currentColor"
//               strokeWidth="2"
//               fill="#fff"
//               fillOpacity=".1"
//             />
//             <path
//               d="M8 2v4M16 2v4M3 10h18"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//             />
//             <circle
//               cx="12"
//               cy="14"
//               r="3"
//               stroke="currentColor"
//               strokeWidth="2"
//               fill="none"
//             />
//           </svg>
//           Scan Document
//         </button>

//         {showOcrModal ? (
//           <OcrUploadModal
//             partiesList={partiesListWithCategories}
//             stocksnames={stocksnames}
//             mutualsnames={mutualsnames}
//             onSubmit={handleOcrSubmit as any}
//             onClose={() => setShowOcrModal(false)}
//             apiUrl={process.env.REACT_APP_API_URL || ''}
//           />
//         ) : null}

//         <h2 className="text-center text-4xl md:text-5xl font-extrabold mb-2 tracking-tighter duo-gradient-text drop-shadow-xl select-none">
//           Sell Stocks
//         </h2>
//         <p className="text-center text-gray-600 mb-7 italic bg-[color:var(--primary)]/10 rounded-xl px-3 py-2 text-base shadow border-l-4 border-[color:var(--secondary)]/30 font-medium">
//           <span className="inline-block px-2 py-1 bg-gradient-to-tr from-[color:var(--primary)]/10 to-[color:var(--secondary)]/10 rounded">
//             Record a new stock sale transaction
//           </span>
//           <br />
//           <span className="font-sans text-sm text-gray-400">
//             Select party, then category, then stock.
//             <br />
//             (Party can be preselected via URL)
//           </span>
//         </p>
//         <form
//           onSubmit={handleSellStockSubmit}
//           className="grid gap-8 grid-cols-1 md:grid-cols-2 animate-fadeInUp"
//           autoComplete="off"
//         >
//           {/* Party */}
//           <div className="col-span-1">
//             <label
//               htmlFor="partyId"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="party">👤</span> Party Name
//             </label>
//             <div className="relative">
//               <select
//                 name="partyId"
//                 id="partyId"
//                 value={sellStockForm.partyId}
//                 onChange={handleFormChange}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f8fbf9] rounded-xl px-5 py-3 text-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]/60 font-semibold transition-all"
//                 required
//                 style={{ color: 'var(--primary)' }}
//               >
//                 <option value="">Choose Party</option>
//                 {partiesList.map((p) => (
//                   <option key={String(p.id)} value={String(p.id)}>
//                     {p.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Category */}
//           <div className="col-span-1">
//             <label
//               htmlFor="category"
//               className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
//             >
//               <span role="img" aria-label="category">📂</span> Category
//             </label>
//             <div className="relative">
//               <select
//                 name="category"
//                 id="category"
//                 value={sellStockForm.category}
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.partyId}
//                 className={`w-full border-2 bg-[#fffcf7] border-[color:var(--secondary)] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-semibold focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all ${
//                   !sellStockForm.partyId ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
//                 }`}
//                 style={{ color: 'var(--secondary)' }}
//               >
//                 <option value="">Select Category</option>
//                 {partyCategories.map((cat) => (
//                   <option key={String(cat)} value={cat}>
//                     {cat}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Stock Name — now shows deduplicated list */}
//           <div className="col-span-1 md:col-span-2">
//             <label
//               htmlFor="stockId"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="stock">🏷️</span> Stock Name
//             </label>
//             <div className="relative">
//               <select
//                 name="stockId"
//                 id="stockId"
//                 value={sellStockForm.stockId}
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.category}
//                 className={`w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-semibold focus:ring-2 focus:ring-[color:var(--primary)]/50 transition-all ${
//                   !sellStockForm.category ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
//                 }`}
//                 style={{ color: 'var(--primary)' }}
//               >
//                 <option value="">Select Stock</option>
//                 {stocksInCurrentCategory.map((stock) => (
//                   <option key={`${stock.category}__${stock.stock_name}`} value={stock.stock_name}>
//                     {stock.stock_name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             {sellStockForm.category && stocksInCurrentCategory.length === 0 && (
//               <p className="text-xs text-center text-red-500 mt-2 font-mono italic">
//                 No stocks available under this category.
//               </p>
//             )}
//           </div>

//           {/* Units To Sell */}
//           <div className="col-span-1">
//             <label
//               htmlFor="sellUnits"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="units">🔢</span> Units To Sell
//               {selectedStockObj && (
//                 <span className="text-xs ml-2 text-gray-400 font-normal">
//                   (Available:{' '}
//                   <b className="text-[color:var(--secondary)]">{selectedStockObj.unit}</b>)
//                 </span>
//               )}
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="sellUnits"
//                 id="sellUnits"
//                 value={sellStockForm.sellUnits}
//                 required
//                 disabled={!sellStockForm.stockId}
//                 min={0}
//                 max={selectedStockObj ? selectedStockObj.unit : undefined}
//                 onChange={handleFormChange}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-medium focus:ring-2 focus:ring-[color:var(--primary)]/40 placeholder-gray-300 transition-all"
//                 placeholder="How many units to sell"
//                 style={{ color: 'var(--primary)' }}
//                 step="any"
//                 inputMode="decimal"
//                 pattern="[0-9.]*"
//               />
//             </div>
//             {sellStockForm.sellUnits &&
//             selectedStockObj &&
//             parseFloat(sellStockForm.sellUnits) > parseFloat(selectedStockObj.unit) ? (
//               <span className="text-xs text-red-600 font-semibold px-2 py-1 inline-block bg-[#ffedf1] rounded mt-1">
//                 Not enough units available!
//               </span>
//             ) : null}
//           </div>

//           {/* Sell Amount */}
//           <div className="col-span-1">
//             <label
//               htmlFor="sellAmount"
//               className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
//             >
//               <span role="img" aria-label="amount">💰</span> Sell Amount
//               <span className="text-xs bg-[#fff8ef] text-[color:var(--primary)] px-2 py-1 rounded font-mono ml-2">
//                 (Auto: {(autoAmount || 0).toFixed(2)}{' '}
//                 {sellStockForm.sellUnits ? 'calculated' : ''})
//               </span>
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="sellAmount"
//                 id="sellAmount"
//                 placeholder={`Auto: ${(autoAmount || 0).toFixed(2)}`}
//                 value={sellStockForm.sellAmount}
//                 min={0}
//                 step="any"
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.stockId}
//                 className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all placeholder-gray-400"
//                 style={{ color: 'var(--secondary)' }}
//                 inputMode="decimal"
//                 pattern="[0-9]*"
//               />
//             </div>
//             <span className="block text-xs text-gray-400 mt-1 font-mono ml-2">
//               Leave blank for auto-calculated. You can adjust if desired.
//             </span>
//           </div>

//           {/* Indirect Charges */}
//           <div className="col-span-1">
//             <label
//               htmlFor="indirectCharges"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="fees">💸</span> Indirect Charges
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="indirectCharges"
//                 id="indirectCharges"
//                 placeholder="Enter indirect charges (if any)"
//                 value={sellStockForm.indirectCharges}
//                 min={0}
//                 step="any"
//                 onChange={handleFormChange}
//                 disabled={!sellStockForm.stockId}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-normal focus:ring-2 focus:ring-[color:var(--primary)]/60 placeholder-gray-300 transition-all"
//                 style={{ color: 'var(--primary)' }}
//               />
//             </div>
//           </div>

//           {/* Date */}
//           <div className="col-span-1">
//             <label
//               htmlFor="date"
//               className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
//             >
//               <span role="img" aria-label="date">📅</span> Date
//             </label>
//             <div className="relative">
//               <input
//                 type="date"
//                 name="date"
//                 id="date"
//                 value={sellStockForm.date}
//                 onChange={handleFormChange}
//                 required
//                 className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/40 transition-all"
//                 disabled={!sellStockForm.stockId}
//                 style={{ color: 'var(--secondary)' }}
//               />
//             </div>
//           </div>

//           {/* Submit */}
//           <div className="col-span-1 md:col-span-2 flex flex-col md:flex-row-reverse justify-between items-center gap-3 pt-2">
//             <button
//               type="submit"
//               disabled={loading}
//               className="px-10 py-3 rounded-full bg-gradient-to-r from-[color:var(--primary)] to-[color:var(--secondary)] text-white font-extrabold text-2xl transform hover:scale-105 active:scale-100 transition-all focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/50 disabled:opacity-60 flex items-center gap-2 border-b-4 border-[color:var(--secondary)]/50"
//               style={{
//                 boxShadow: '0 8px 48px 3px #94efd990, 0 3px 15px -2px #f8bb498f',
//               }}
//             >
//               {loading ? (
//                 <>
//                   <svg
//                     className="animate-spin mr-2 h-6 w-6 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     />
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v8z"
//                     />
//                   </svg>
//                   Selling...
//                 </>
//               ) : (
//                 <>
//                   <span role="img" aria-label="sell">💸</span> Sell Stock
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//       <style>{`
//         :root {
//           --primary: ${PRIMARY};
//           --secondary: ${SECONDARY};
//         }
//         .duo-gradient-text {
//           background: linear-gradient(90deg, var(--primary), var(--secondary) 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//         }
//         @media (max-width: 600px){
//           .duo-form-glow:before, .duo-form-glow:after{display:none;}
//         }
//         .animate-fadein{
//           animation: fadeInLeft 0.7s cubic-bezier(.29,.31,.41,1.41);
//         }
//         @keyframes fadeInLeft{
//           0%{ opacity:0; transform:translateX(-100%);}
//           80%{ opacity:0.2;}
//           100%{ opacity:1; transform: translateX(0);}
//         }
//         .animate-fadeInUp {
//           animation: fadeInUp 1.0s cubic-bezier(.38,.33,.52,1.42);
//         }
//         @keyframes fadeInUp {
//           0% {opacity: 0; transform: translateY(40px);}
//           100% {opacity: 1; transform: translateY(0);}
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SellStocksPage;

import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import * as XLSX from 'xlsx';
import parties from '../data/party';
import stockdata from '../data/stock';
import sellstocks from '../data/sellstocks';
import settingapi from '../data/setting';
import OcrUploadModal from './OcrUploadModal';

interface Party {
  id: number;
  name: string;
  total_amount?: number | string;
}

type SellStockRecord = {
  id: number;
  party_id: number;
  category: string;
  stock_id: string;
  stock_name: string;
  sell_units: string;
  sell_amount: string;
  indirect_charges: string;
  date: string;
  catrgories?: string;
};

interface StockDBCategoryItem {
  id: number | string;
  investment_type: string;
  category: string;
  stock_name: string;
  unit: string;
  total_amount: string;
  indirect_charges: string;
  perUnitCharge: string;
}

// Deduplicated stock with merged units/amounts across DB rows
interface MergedStockItem {
  stock_name: string;
  category: string;
  unit: string;          // sum of remaining units across all rows
  total_amount: string;  // sum of total_amount across all rows
  indirect_charges: string;
  perUnitCharge: string; // weighted average
  investment_type: string;
  // Keep ids of all source rows for reference
  sourceIds: (number | string)[];
}

type SellStockFormState = {
  partyId: string;
  category: string;
  stockId: string | number;
  stockName: string;
  sellUnits: string;
  sellAmount: string;
  indirectCharges: string;
  date: string;
};

// ─────────────────────────────────────────────────────────────────────────────
// EXCEL / XML BULK-SELL IMPORT TYPES
// ─────────────────────────────────────────────────────────────────────────────

type ExcelRow = {
  stock_name: string;
  unit: string | number;
  total_amount: string | number;
  indirect_charges?: string | number;
  date?: string;
  [key: string]: any;
};

type SheetData = {
  sheetName: string;
  fileName: string;
  fileIndex: number;
  rows: ExcelRow[];
};

type StockMatchStatus = 'matched' | 'fuzzy' | 'unmatched';

type ProcessedExcelRow = ExcelRow & {
  _rowId: string;
  _sheetKey: string;
  _matchStatus: StockMatchStatus;
  _matchedName?: string;
  _candidateMatches?: string[];
  _userChoice?: string; // after user resolves
};

type ExcelUploadStep = 'idle' | 'setup' | 'review';

const PRIMARY = '#17946B';
const SECONDARY = '#FF9500';

async function fetchSellStocks(): Promise<SellStockRecord[]> {
  try {
    const res = await sellstocks();
    if (res && typeof res.json === 'function') {
      if (!res.ok) return [];
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    } else if (Array.isArray(res)) {
      return res;
    }
    return [];
  } catch {
    return [];
  }
}

function getSellUnitsForStock(
  sellStocks: SellStockRecord[],
  partyId: string,
  category: string,
  stockName: string
): number {
  return sellStocks.reduce((sum, rec) => {
    if (
      String(rec.party_id) === String(partyId) &&
      String(rec.category) === String(category) &&
      String(rec.stock_id) === String(stockName)
    ) {
      return sum + parseFloat(rec.sell_units || '0');
    }
    return sum;
  }, 0);
}

function getPartyStocksAdjusted(
  stocksDbRows: any[],
  sellStocks: SellStockRecord[],
  partyId: string
) {
  let result: { [category: string]: StockDBCategoryItem[] } = {};
  for (const row of stocksDbRows) {
    if (String(row.party_id) !== String(partyId)) continue;
    let catsArr: StockDBCategoryItem[] = [];
    if (typeof row.categories === 'string') {
      try {
        const parsed = JSON.parse(row.categories);
        catsArr = Array.isArray(parsed) ? parsed : [];
      } catch {
        catsArr = [];
      }
    } else if (Array.isArray(row.categories)) {
      catsArr = row.categories as StockDBCategoryItem[];
    }
    for (const item of catsArr) {
      const soldUnits = getSellUnitsForStock(
        sellStocks,
        partyId,
        item.category,
        item.stock_name
      );
      let origUnit = parseFloat(item.unit || '0');
      let remainingUnit = origUnit - soldUnits;
      const adjustedItem = {
        ...item,
        unit: remainingUnit >= 0 ? String(remainingUnit) : '0',
      };
      if (!result[item.category]) result[item.category] = [];
      result[item.category].push(adjustedItem);
    }
  }
  return result;
}

/**
 * Merges duplicate stock entries (same stock_name + category) across multiple
 * DB rows into a single item, summing units and amounts, computing weighted avg
 * perUnitCharge, and dropping entries with 0 remaining units.
 */
function mergeStocksByName(items: StockDBCategoryItem[]): MergedStockItem[] {
  const map = new Map<string, MergedStockItem>();

  for (const item of items) {
    const key = `${item.category}__${item.stock_name}`;
    const unit = parseFloat(item.unit || '0');
    const totalAmount = parseFloat(item.total_amount || '0');
    const indirectCharges = parseFloat(item.indirect_charges || '0');

    if (map.has(key)) {
      const existing = map.get(key)!;
      const newUnit = parseFloat(existing.unit) + unit;
      const newTotal = parseFloat(existing.total_amount) + totalAmount;
      const newIndirect = parseFloat(existing.indirect_charges) + indirectCharges;
      const newPerUnit = newUnit > 0 ? ((newTotal + newIndirect) / newUnit).toFixed(2) : '0.00';

      map.set(key, {
        ...existing,
        unit: String(newUnit),
        total_amount: String(newTotal),
        indirect_charges: String(newIndirect),
        perUnitCharge: newPerUnit,
        sourceIds: [...existing.sourceIds, item.id],
      });
    } else {
      map.set(key, {
        stock_name: item.stock_name,
        category: item.category,
        unit: String(unit),
        total_amount: String(totalAmount),
        indirect_charges: String(indirectCharges),
        perUnitCharge: item.perUnitCharge || (unit > 0 ? ((totalAmount + indirectCharges) / unit).toFixed(2) : '0.00'),
        investment_type: item.investment_type,
        sourceIds: [item.id],
      });
    }
  }

  // Filter out stocks with 0 remaining units
  return Array.from(map.values()).filter(
    s => !!(s.stock_name && s.stock_name.trim()) && parseFloat(s.unit) > 0
  );
}

function safeNumber(v: any): number {
  const n = parseFloat(String(v));
  return isNaN(n) ? 0 : n;
}

// ─────────────────────────────────────────────────────────────────────────────
// FUZZY MATCHING (same approach used on the Add-stock import screen)
// ─────────────────────────────────────────────────────────────────────────────

function buildNormalizedIndex(list: string[]): Map<string, string> {
  const map = new Map<string, string>();
  for (const name of list) {
    map.set(name.toLowerCase().replace(/[^a-z0-9]/g, ''), name);
  }
  return map;
}

function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
  );
  for (let i = 1; i <= m; i++)
    for (let j = 1; j <= n; j++)
      dp[i][j] = a[i - 1] === b[j - 1] ? dp[i - 1][j - 1] : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
  return dp[m][n];
}

function fuzzyMatchFast(
  name: string,
  normalizedIndex: Map<string, string>
): { matched?: string; candidates: string[]; status: StockMatchStatus } {
  const lower = name.toLowerCase().replace(/[^a-z0-9]/g, '');

  const exactOriginal = normalizedIndex.get(lower);
  if (exactOriginal) {
    return { matched: exactOriginal, candidates: [], status: 'matched' };
  }

  const candidates: string[] = [];
  for (const [normName, origName] of normalizedIndex.entries()) {
    if (normName.includes(lower) || lower.includes(normName)) {
      candidates.push(origName);
      if (candidates.length >= 5) break;
    }
  }
  if (candidates.length > 0) {
    return { matched: undefined, candidates, status: 'fuzzy' };
  }

  const levenCandidates: string[] = [];
  for (const [normName, origName] of normalizedIndex.entries()) {
    if (Math.abs(normName.length - lower.length) > 4) continue;
    if (levenshtein(lower, normName) <= 3) {
      levenCandidates.push(origName);
      if (levenCandidates.length >= 5) break;
    }
  }

  return levenCandidates.length > 0
    ? { matched: undefined, candidates: levenCandidates, status: 'fuzzy' }
    : { matched: undefined, candidates: [], status: 'unmatched' };
}

// ─────────────────────────────────────────────────────────────────────────────
// XML PARSING (mirrors the Add-stock import: generic row schema + Tally MF ledger)
// ─────────────────────────────────────────────────────────────────────────────

const XML_FIELD_ALIASES: { [key: string]: string[] } = {
  stock_name: ['stock_name', 'stockname', 'name', 'stock', 'security', 'scrip', 'symbol'],
  unit: ['unit', 'units', 'sell_units', 'sellunits', 'qty', 'quantity'],
  total_amount: ['total_amount', 'totalamount', 'sell_amount', 'sellamount', 'amount', 'price', 'value', 'totalvalue'],
  indirect_charges: ['indirect_charges', 'indirectcharges', 'charges', 'charge', 'brokerage'],
};

function normalizeTag(tag: string): string {
  return tag.toLowerCase().replace(/[^a-z0-9]/g, '');
}

function getXmlField(el: Element, aliases: string[]): string {
  for (const a of aliases) {
    for (const attr of Array.from(el.attributes)) {
      if (normalizeTag(attr.name) === normalizeTag(a)) return attr.value.trim();
    }
  }
  for (const child of Array.from(el.children)) {
    const tag = normalizeTag(child.tagName);
    if (aliases.some(a => normalizeTag(a) === tag)) {
      return (child.textContent || '').trim();
    }
  }
  return '';
}

function findXmlRowElements(doc: Document): Element[] {
  const rowTagCandidates = ['row', 'stock', 'item', 'entry', 'record', 'transaction', 'holding'];
  for (const tag of rowTagCandidates) {
    const found = Array.from(doc.getElementsByTagName(tag));
    if (found.length) return found;
  }
  const root = doc.documentElement;
  if (!root) return [];
  const counts: { [tag: string]: Element[] } = {};
  const walk = (el: Element) => {
    for (const child of Array.from(el.children)) {
      (counts[child.tagName] = counts[child.tagName] || []).push(child);
      walk(child);
    }
  };
  walk(root);
  let best: Element[] = [];
  for (const arr of Object.values(counts)) {
    if (arr.length > best.length) best = arr;
  }
  return best.length > 1 ? best : [];
}

// ── Tally-style ledger export (same schema handled on the Add-stock screen) ──
function isTallyMfXml(doc: Document): boolean {
  return !!doc.querySelector('DSPACCNAME') && !!doc.querySelector('DSPSTKINFO');
}

function convertTallyDate(raw: string): string {
  const m = raw.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/);
  if (!m) return '';
  const [, dd, mm, yyRaw] = m;
  const yyyy = yyRaw.length === 4 ? yyRaw : `20${yyRaw}`;
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}

function parseTallyMfXml(doc: Document): ExcelRow[] {
  const root = doc.documentElement;
  if (!root) return [];
  const rows: ExcelRow[] = [];

  let currentFundName = '';
  let pendingDate = '';
  let seenFirstStkInfoForFund = false;

  for (const child of Array.from(root.children)) {
    const tag = child.tagName.toUpperCase();

    if (tag === 'DSPACCNAME') {
      currentFundName = (child.querySelector('DSPDISPNAME')?.textContent || '').trim();
      seenFirstStkInfoForFund = false;
      pendingDate = '';
      continue;
    }

    if (tag === 'SSBATCHNAME') {
      pendingDate = convertTallyDate(child.querySelector('SSBATCH')?.textContent || '');
      continue;
    }

    if (tag === 'DSPSTKINFO') {
      const stkcl = child.querySelector('DSPSTKCL');
      if (!stkcl) continue;

      if (!seenFirstStkInfoForFund) {
        seenFirstStkInfoForFund = true;
        continue;
      }

      const qtyRaw = (stkcl.querySelector('DSPCLQTY')?.textContent || '').trim();
      const amtRaw = (stkcl.querySelector('DSPCLAMTA')?.textContent || '').trim();
      const qty = parseFloat(qtyRaw.replace(/[^0-9.\-]/g, '')) || 0;
      const amt = Math.abs(safeNumber(amtRaw));

      if (currentFundName) {
        rows.push({
          stock_name: currentFundName,
          unit: qty,
          total_amount: amt,
          indirect_charges: '0',
          date: pendingDate,
        });
      }
      pendingDate = '';
    }
  }

  return rows;
}

async function readFileAsText(file: File): Promise<string> {
  const buf = await file.arrayBuffer();
  const bytes = new Uint8Array(buf);

  if (bytes.length >= 2 && bytes[0] === 0xff && bytes[1] === 0xfe) {
    return new TextDecoder('utf-16le').decode(buf);
  }
  if (bytes.length >= 2 && bytes[0] === 0xfe && bytes[1] === 0xff) {
    return new TextDecoder('utf-16be').decode(buf);
  }
  if (bytes.length >= 3 && bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
    return new TextDecoder('utf-8').decode(buf);
  }
  const sampleLen = Math.min(bytes.length, 200);
  let nulCount = 0;
  for (let i = 0; i < sampleLen; i++) if (bytes[i] === 0x00) nulCount++;
  if (sampleLen > 0 && nulCount / sampleLen > 0.25) {
    return new TextDecoder('utf-16le').decode(buf);
  }
  return new TextDecoder('utf-8').decode(buf);
}

function parseXmlRows(xmlText: string): ExcelRow[] {
  const parser = new DOMParser();
  const doc = parser.parseFromString(xmlText, 'application/xml');
  if (doc.querySelector('parsererror')) return [];

  if (isTallyMfXml(doc)) {
    const tallyRows = parseTallyMfXml(doc);
    if (tallyRows.length) return tallyRows;
  }

  const rowElements = findXmlRowElements(doc);

  return rowElements
    .map(el => ({
      stock_name: getXmlField(el, XML_FIELD_ALIASES.stock_name),
      unit: getXmlField(el, XML_FIELD_ALIASES.unit),
      total_amount: getXmlField(el, XML_FIELD_ALIASES.total_amount),
      indirect_charges: getXmlField(el, XML_FIELD_ALIASES.indirect_charges) || '0',
    } as ExcelRow))
    .filter(r => r.stock_name);
}

const SellStocksPage = () => {
  const [partiesList, setPartiesList] = useState<Party[]>([]);
  const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);
  const [stocksDataDb, setStocksDataDb] = useState<any[]>([]);
  const [totalamountspend, setTotalAmmountSpend] = useState<Number>();
  const [showOcrModal, setShowOcrModal] = useState(false);
  const [farmName, setFarmName] = useState<string>();

  const [sellStockForm, setSellStockForm] = useState<SellStockFormState>({
    partyId: '',
    category: '',
    stockId: '',
    stockName: '',
    sellUnits: '',
    sellAmount: '',
    indirectCharges: '',
    date: '',
  });
  const [autoAmount, setAutoAmount] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  // ── Excel / XML bulk-sell import state ───────────────────────────────────
  const [excelUploadStep, setExcelUploadStep] = useState<ExcelUploadStep>('idle');
  const [excelSetupPartyId, setExcelSetupPartyId] = useState('');
  const [excelSetupCategory, setExcelSetupCategory] = useState('');
  const [excelSetupDate, setExcelSetupDate] = useState('');
  const [excelFiles, setExcelFiles] = useState<File[]>([]);
  const [processedRows, setProcessedRows] = useState<{ [sheetKey: string]: ProcessedExcelRow[] }>({});
  const [excelSubmitLoading, setExcelSubmitLoading] = useState(false);
  const [excelParsing, setExcelParsing] = useState(false);
  const [excelSetupError, setExcelSetupError] = useState<string | null>(null);
  const excelFileInputRef = useRef<HTMLInputElement>(null);

  const hasXmlFile = excelFiles.some(f => f.name.toLowerCase().endsWith('.xml'));

  useEffect(() => {
    async function fetchSettingsApi() {
      try {
        const res = await settingapi();
        if (Array.isArray(res)) {
          const farmSetting = res.find((item: any) => item.meta_key === 'farm');
          if (farmSetting && farmSetting.meta_value !== undefined) {
            let farmObj = {};
            try {
              farmObj =
                typeof farmSetting.meta_value === 'string'
                  ? JSON.parse(farmSetting.meta_value)
                  : farmSetting.meta_value;
            } catch {}
            if (
              farmObj &&
              typeof farmObj === 'object' &&
              farmObj !== null &&
              'name' in farmObj &&
              typeof (farmObj as { name?: unknown }).name === 'string'
            ) {
              setFarmName((farmObj as { name: string }).name);
            }
          }
        }
      } catch {}
    }
    fetchSettingsApi();
  }, []);

  useEffect(() => {
    async function loadSellStocks() {
      const sellArr = await fetchSellStocks();
      setSellStocks(sellArr);
    }
    loadSellStocks();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get('party') || '';
    setSellStockForm((s) => ({ ...s, partyId }));
  }, []);

  useEffect(() => {
    (async () => {
      const pts = await parties();
      setPartiesList(Array.isArray(pts) ? pts : []);
      const db = await stockdata();
      setStocksDataDb(Array.isArray(db) ? db : []);
    })();
  }, []);

  async function fetchParties() {
    const pts = await parties();
    setPartiesList(Array.isArray(pts) ? pts : []);
  }

  // Raw (unadjusted) stocks by category for the selected party
  const partyStocksByCat = useMemo(
    () => getPartyStocksAdjusted(stocksDataDb, sellStocks, sellStockForm.partyId),
    [stocksDataDb, sellStocks, sellStockForm.partyId]
  );

  const partyCategories = useMemo(() => Object.keys(partyStocksByCat), [partyStocksByCat]);

  // Raw items for the selected category (may have duplicates)
  const rawStocksInCategory = useMemo(
    () =>
      sellStockForm.category ? partyStocksByCat[sellStockForm.category] || [] : [],
    [sellStockForm.category, partyStocksByCat]
  );

  // Deduplicated, merged stocks — one entry per unique stock_name with 0-unit entries removed
  const stocksInCurrentCategory = useMemo(
    () => mergeStocksByName(rawStocksInCategory),
    [rawStocksInCategory]
  );

  // The selected merged stock object
  const selectedStockObj = useMemo(
    () =>
      stocksInCurrentCategory.find(
        (s) => String(s.stock_name) === String(sellStockForm.stockName)
      ),
    [sellStockForm.stockName, stocksInCurrentCategory]
  );

  useEffect(() => {
    const unitsNum = parseFloat(sellStockForm.sellUnits || '0');
    if (!selectedStockObj || isNaN(unitsNum) || unitsNum <= 0) {
      setAutoAmount(0);
      return;
    }
    const totalAvailableUnits = parseFloat(selectedStockObj.unit);
    const amount = parseFloat(selectedStockObj.total_amount);
    const amt = totalAvailableUnits > 0 ? (amount / totalAvailableUnits) * unitsNum : 0;
    setAutoAmount(amt);
  }, [sellStockForm.sellUnits, selectedStockObj]);

  const fetchUserRemainingBalance = useCallback(
    async (partyId: string) => {
      if (!partyId) {
        setTotalAmmountSpend(0);
        return;
      }
      try {
        const usermetaResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/updateusermeta`
        );
        const usermetaList = await usermetaResponse.json();
        const foundMeta = usermetaList.find(
          (meta: any) =>
            meta.meta_key === 'remaining' && String(meta.party_id) === String(partyId)
        );
        if (foundMeta) {
          setTotalAmmountSpend(Number(foundMeta.meta_value));
        } else {
          const party = partiesList.find((p) => String(p.id) === String(partyId));
          setTotalAmmountSpend(Number(party?.total_amount || 0));
        }
      } catch (err) {
        console.error('Error fetching usermeta:', err);
        setTotalAmmountSpend(0);
      }
    },
    [partiesList]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get('party') || '';
    fetchUserRemainingBalance(partyId);
  }, [fetchUserRemainingBalance]);

  // --- UI EVENT HANDLERS ---
  const handleFormChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === 'sellUnits') {
      if (selectedStockObj) {
        const maxUnits = parseFloat(selectedStockObj.unit || '0');
        if (value === '' || value === undefined) {
          setSellStockForm((s) => ({ ...s, sellUnits: '' }));
          return;
        }
        const entered = parseFloat(value);
        if (isNaN(entered) || entered < 0) return;
        if (entered > maxUnits) {
          setSellStockForm((s) => ({ ...s, sellUnits: maxUnits.toString() }));
          return;
        }
        setSellStockForm((s) => ({ ...s, sellUnits: value }));
        return;
      }
    }

    if (name === 'sellAmount') {
      if (selectedStockObj) {
        if (value === '' || value === undefined) {
          setSellStockForm((s) => ({ ...s, sellAmount: '' }));
          return;
        }
        const entered = parseFloat(value);
        if (isNaN(entered) || entered < 0) return;
        setSellStockForm((s) => ({ ...s, sellAmount: value }));
        return;
      }
    }

    let patch: Partial<SellStockFormState> = { [name]: value };
    if (name === 'partyId') {
      patch.category = '';
      patch.stockId = '';
      patch.stockName = '';
      patch.sellUnits = '';
      patch.sellAmount = '';
      patch.date = '';
    }
    if (name === 'category') {
      patch.stockId = '';
      patch.stockName = '';
      patch.sellUnits = '';
      patch.sellAmount = '';
    }
    if (name === 'stockId') {
      // value is stock_name (used as the option value)
      const found = stocksInCurrentCategory.find(
        (s) => String(s.stock_name) === value
      );
      patch.stockName = found ? found.stock_name : '';
      patch.stockId = found ? found.stock_name : '';
    }
    setSellStockForm((s) => ({ ...s, ...patch }));
  };

  // ─── OCR submit — mirrors handleSellStockSubmit for sell flow ───────────────
  // NOTE: OcrUploadModal batches are purchase records (buy flow).
  // This handler processes each OCR batch row as a SELL transaction,
  // matching the same invoice / buysellrecord / usermeta pattern used in
  // handleSellStockSubmit.
  // Also reused directly by the Excel/XML bulk-import flow below — its rows
  // already carry `stock_name` + `unit`/`total_amount` (or `sell_units` /
  // `sell_amount`), which this handler already falls back to.
  const handleOcrSubmit = async ({
    partyId,
    category,
    batches,
  }: {
    partyId: string;
    category: string;
    batches: { date: string; rows: any[] }[];
  }): Promise<void> => {
    if (!partyId) { alert('Please select a party'); return; }
    if (!category) { alert('Please select a category'); return; }

    for (const batch of batches) {
      if (!batch.date) continue;
      const validRows = batch.rows.filter((r: any) => r.stock_name?.trim());
      if (!validRows.length) continue;

      for (const row of validRows) {
        // Resolve the merged stock to get accurate available units & per-unit price
        const mergedStock = stocksInCurrentCategory.find(
          (s) => s.stock_name === row.stock_name && s.category === category
        );

        const sellUnitsNumber = safeNumber(row.sell_units ?? row.unit);
        if (!sellUnitsNumber || sellUnitsNumber <= 0) continue;

        if (mergedStock) {
          const available = parseFloat(mergedStock.unit);
          if (sellUnitsNumber > available) {
            alert(
              `Not enough units for "${row.stock_name}". ` +
              `Available: ${available}, Requested: ${sellUnitsNumber}`
            );
            continue;
          }
        }

        // Determine sell amount — prefer explicit value, else auto-calculate
        let sellAmount = safeNumber(row.sell_amount ?? row.total_amount);
        if (!sellAmount && mergedStock) {
          const availableUnits = parseFloat(mergedStock.unit);
          const totalAmt = parseFloat(mergedStock.total_amount);
          sellAmount =
            availableUnits > 0 ? (totalAmt / availableUnits) * sellUnitsNumber : 0;
        }

        const indirectCharges = safeNumber(row.indirect_charges ?? 0);
        const netSale = sellAmount - indirectCharges;

        // 1) Main sellstocks record
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              party_id: partyId,
              category,
              stock_id: row.stock_name,    // stock_id stored as name, same as handleSellStockSubmit
              stock_name: row.stock_name,
              sell_units: sellUnitsNumber,
              sell_amount: sellAmount,
              indirect_charges: indirectCharges,
              date: batch.date,
            }),
          });
          if (!res.ok) {
            console.error('sellstocks POST failed for', row.stock_name);
            continue;
          }
        } catch (err) {
          console.error('sellstocks POST error', err);
          continue;
        }

        // 2) Invoice record — sell type, mirrors handleSellStockSubmit exactly
        try {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              farm: farmName,
              party: partyId,
              invoice_type: 'sell',
              date: batch.date,
              datainvoice: JSON.stringify([
                {
                  stock_id: row.stock_name,
                  stock_name: row.stock_name,
                  category,
                  sell_units: sellUnitsNumber,
                  sell_amount: sellAmount,
                  indirect_charges: indirectCharges,
                  total_amount: sellAmount,
                  date: batch.date,
                },
              ]),
            }),
          });
        } catch (err) {
          console.error('Invoice POST error', err);
        }

        // 3) buysellrecord — mirrors handleSellStockSubmit logic
        try {
          let perUnitPrice = 0;
          if (mergedStock) {
            perUnitPrice = safeNumber(mergedStock.perUnitCharge);
            if (!perUnitPrice) {
              const totalAmountVal = parseFloat(mergedStock.total_amount) || 0;
              // restore sold units to approximate original total
              const totalUnitsVal = parseFloat(mergedStock.unit) + sellUnitsNumber;
              perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
            }
          }
          const totalpurchase = sellUnitsNumber * perUnitPrice;
          const totalsell = netSale;

          const latestRes = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
          );
          const latestList = await latestRes.json();
          const latestEntry =
            Array.isArray(latestList) && latestList.length > 0
              ? latestList[latestList.length - 1]
              : null;

          if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
            const prevTotalSell = safeNumber(latestEntry.totalsell);
            const newTotalSell = prevTotalSell + totalsell;
            const newClosingBLC = safeNumber(latestEntry.totalpurchase) - newTotalSell;

            await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: latestEntry.id,
                date: batch.date,
                totalpurchase: latestEntry.totalpurchase,
                totalsell: newTotalSell,
                closingBLC: newClosingBLC,
              }),
            });
          } else {
            await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                date: batch.date,
                totalpurchase,
                totalsell,
                closingBLC: 0 - totalpurchase + totalsell,
              }),
            });
          }
        } catch (err) {
          console.error('buysellrecord error', err);
        }

        // 4) usermeta "remaining" — mirrors handleSellStockSubmit handleUserMetaUpdate
        try {
          const umRes = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`
          );
          const umList = await umRes.json();
          const foundMeta = Array.isArray(umList)
            ? umList.find(
                (m: any) =>
                  m.meta_key === 'remaining' && String(m.party_id) === String(partyId)
              )
            : null;

          if (foundMeta) {
            const oldVal = safeNumber(foundMeta.meta_value);
            await fetch(
              `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
              {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  meta_key: 'remaining',
                  meta_value: (oldVal + netSale).toString(),
                  party_id: partyId,
                }),
              }
            );
          } else {
            const party = partiesList.find((p) => String(p.id) === String(partyId));
            const baseAmount = safeNumber(party?.total_amount ?? 0);
            await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                meta_key: 'remaining',
                meta_value: (baseAmount + netSale).toString(),
                party_id: partyId,
              }),
            });
          }

          // Keep local state in sync
          setTotalAmmountSpend((prev) => (safeNumber(prev) || 0) + netSale);
        } catch (err) {
          console.error('usermeta error', err);
        }
      }
    }

    await fetchParties();
    // Refresh sell stocks so UI reflects new sales
    const sellArr = await fetchSellStocks();
    setSellStocks(sellArr);
    setShowOcrModal(false);
  };

  const handleSellStockSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!sellStockForm.partyId) return alert('Select party');
    if (!sellStockForm.category) return alert('Select category');
    if (!sellStockForm.stockId) return alert('Select stock');
    const sellUnitsNumber = parseFloat(sellStockForm.sellUnits || '0');
    if (!sellUnitsNumber || isNaN(sellUnitsNumber) || sellUnitsNumber <= 0)
      return alert('Please enter valid units to sell');
    if (!selectedStockObj) return alert('Select valid stock');
    if (sellUnitsNumber > parseFloat(selectedStockObj.unit || '0')) {
      return alert(
        `Not enough units available to sell! Available: ${selectedStockObj.unit}, Requested: ${sellUnitsNumber}`
      );
    }
    if (!sellStockForm.date) return alert('Select date for sell');

    const sellAmount =
      Number(sellStockForm.sellAmount) > 0
        ? Number(sellStockForm.sellAmount)
        : typeof autoAmount !== 'undefined'
        ? Number(autoAmount)
        : 0;
    const indirectCharges = Number(sellStockForm.indirectCharges) || 0;
    const netSale = sellAmount - indirectCharges;

    const handleUserMetaUpdate = async () => {
      try {
        const usermetaResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${sellStockForm.partyId}`
        );
        const usermetaList = await usermetaResponse.json();
        const foundMeta = Array.isArray(usermetaList)
          ? usermetaList.find(
              (meta: any) =>
                meta.meta_key === 'remaining' &&
                String(meta.party_id) === String(sellStockForm.partyId)
            )
          : undefined;

        if (foundMeta) {
          const oldVal = parseFloat(foundMeta.meta_value || '0');
          const meta_value = (oldVal + netSale).toString();
          await fetch(
            `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
            {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                meta_key: 'remaining',
                meta_value,
                party_id: sellStockForm.partyId,
              }),
            }
          );
        } else {
          const oldVal = Number(totalamountspend) || 0;
          const remaining = (oldVal + netSale).toString();
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              meta_key: 'remaining',
              meta_value: remaining,
              party_id: sellStockForm.partyId,
            }),
          });
        }
      } catch (err) {
        console.error('Usermeta API failed', err);
      }
    };

    setLoading(true);
    try {
      const payload = {
        party_id: sellStockForm.partyId,
        category: sellStockForm.category,
        stock_id: sellStockForm.stockId,
        stock_name: sellStockForm.stockName,
        sell_units: sellUnitsNumber,
        sell_amount: sellAmount,
        indirect_charges: sellStockForm.indirectCharges,
        date: sellStockForm.date,
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result?.message || 'Failed to sell stock');

      // Invoice
      try {
        const invoiceData = {
          farm: farmName,
          party: sellStockForm.partyId,
          invoice_type: 'sell',
          date: sellStockForm.date,
          datainvoice: JSON.stringify([
            {
              stock_id: sellStockForm.stockId,
              stock_name: sellStockForm.stockName,
              category: sellStockForm.category,
              sell_units: sellUnitsNumber,
              sell_amount: sellAmount,
              indirect_charges: sellStockForm.indirectCharges,
              total_amount: sellAmount,
              date: sellStockForm.date,
            },
          ]),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(invoiceData),
        });
      } catch (err) {
        console.error('Error adding sell invoice:', err);
      }

      // buysellrecord
      try {
        let perUnitPrice = 0;
        if (selectedStockObj) {
          perUnitPrice = Number(selectedStockObj.perUnitCharge);
          if (!perUnitPrice || isNaN(perUnitPrice)) {
            const totalAmountVal = parseFloat(selectedStockObj.total_amount) || 0;
            const totalUnitsVal = parseFloat(selectedStockObj.unit) + sellUnitsNumber;
            perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
          }
        }
        const totalpurchase = sellUnitsNumber * perUnitPrice;
        const totalsell = netSale;

        const latestRes = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
        );
        const latestList = await latestRes.json();
        const latestEntry =
          Array.isArray(latestList) && latestList.length > 0
            ? latestList[latestList.length - 1]
            : null;

        if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
          const prevTotalSell = Number(latestEntry.totalsell) || 0;
          const newTotalSell = prevTotalSell + totalsell;
          const newClosingBLC =
            (Number(latestEntry.totalpurchase) || 0) - newTotalSell;

          await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: latestEntry.id,
              date: sellStockForm.date,
              totalpurchase: latestEntry.totalpurchase,
              totalsell: newTotalSell,
              closingBLC: newClosingBLC,
            }),
          });
        } else {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              date: sellStockForm.date,
              totalpurchase,
              totalsell,
              closingBLC: 0 - totalpurchase + totalsell,
            }),
          });
        }
      } catch (err) {
        console.error('Failed to send buysellrecord', err);
      }

      setTotalAmmountSpend((prev) => (Number(prev) || 0) + netSale);
      await handleUserMetaUpdate();

      alert('Stock sell recorded successfully!');
      setSellStockForm({
        partyId: sellStockForm.partyId,
        category: '',
        stockId: '',
        stockName: '',
        sellUnits: '',
        sellAmount: '',
        indirectCharges: '',
        date: '',
      });
      window.location.reload();
    } catch (err: any) {
      alert('Error: ' + (err?.message ?? 'Something went wrong'));
    } finally {
      setLoading(false);
    }
  };

  // OcrUploadModal reads `p?.categories` from each party to build its Category dropdown.
  // Our Party type doesn't include categories, so we enrich the list here from stocksDataDb.
  const partiesListWithCategories = useMemo(() => {
    return partiesList.map(party => {
      const cats = new Set<string>();
      for (const row of stocksDataDb) {
        if (String(row.party_id) !== String(party.id)) continue;
        let arr: any[] = [];
        try {
          arr = typeof row.categories === 'string'
            ? JSON.parse(row.categories)
            : Array.isArray(row.categories) ? row.categories : [];
        } catch { arr = []; }
        for (const item of arr) {
          if (item?.category) cats.add(item.category);
        }
      }
      return { ...party, categories: Array.from(cats) };
    });
  }, [partiesList, stocksDataDb]);

  // OcrUploadModal expects { id: number; name: string }[] for stocksnames / mutualsnames.
  // Build from ALL rows in stocksDataDb (not just selected party) so the modal's
  // react-select dropdown has the full list regardless of which party is picked.
  //   - mutualsnames → categories containing "mutual" (case-insensitive)
  //   - stocksnames  → everything else
  const { stocksnames, mutualsnames } = useMemo(() => {
    const stocksSet = new Map<string, { id: number; name: string }>();
    const mutualsSet = new Map<string, { id: number; name: string }>();
    let counter = 1;

    for (const row of stocksDataDb) {
      let arr: StockDBCategoryItem[] = [];
      try {
        arr = typeof row.categories === 'string'
          ? JSON.parse(row.categories)
          : Array.isArray(row.categories) ? row.categories : [];
      } catch { arr = []; }

      for (const item of arr) {
        if (!item?.stock_name?.trim()) continue;
        const isMutual = item.category?.toLowerCase().includes('mutual');
        const target = isMutual ? mutualsSet : stocksSet;
        if (!target.has(item.stock_name)) {
          target.set(item.stock_name, { id: counter++, name: item.stock_name });
        }
      }
    }

    return {
      stocksnames: Array.from(stocksSet.values()),
      mutualsnames: Array.from(mutualsSet.values()),
    };
  }, [stocksDataDb]);

  // ─────────────────────────────────────────────────────────────────────────
  // EXCEL / XML BULK-SELL IMPORT — derived data
  // ─────────────────────────────────────────────────────────────────────────

  // Available (unsold) stock, by category, for whichever party is chosen in
  // the import modal — independent from the single-sell form above.
  const excelPartyStocksByCat = useMemo(
    () => getPartyStocksAdjusted(stocksDataDb, sellStocks, excelSetupPartyId),
    [stocksDataDb, sellStocks, excelSetupPartyId]
  );
  const excelSetupCategories = useMemo(
    () => Object.keys(excelPartyStocksByCat),
    [excelPartyStocksByCat]
  );
  const excelStocksInCategory = useMemo(
    () =>
      mergeStocksByName(
        excelSetupCategory ? excelPartyStocksByCat[excelSetupCategory] || [] : []
      ),
    [excelSetupCategory, excelPartyStocksByCat]
  );

  const handleExcelFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    setExcelFiles(prev => [...prev, ...files]);
    setExcelSetupError(null);
  };

  const removeExcelFile = (idx: number) => {
    setExcelFiles(prev => prev.filter((_, i) => i !== idx));
  };

  // Parses every uploaded file into the shared SheetData[] shape, branching by
  // extension: .xml goes through parseXmlRows (DOMParser-based), everything
  // else is treated as a spreadsheet via the xlsx library.
  const parseImportFiles = async (): Promise<{ sheets: SheetData[]; warnings: string[] }> => {
    const allSheets: SheetData[] = [];
    const fileParseWarnings: string[] = [];
    for (let fi = 0; fi < excelFiles.length; fi++) {
      const file = excelFiles[fi];
      const isXml = file.name.toLowerCase().endsWith('.xml');

      if (isXml) {
        try {
          const text = await readFileAsText(file);
          const rows = parseXmlRows(text);
          if (rows.length) {
            allSheets.push({ sheetName: 'XML Data', fileName: file.name, fileIndex: fi, rows });
          } else {
            fileParseWarnings.push(`${file.name}: parsed but found 0 usable rows — check the file structure.`);
          }
        } catch (err: any) {
          fileParseWarnings.push(`${file.name}: failed to read/parse (${err?.message || 'unknown error'}).`);
        }
        continue;
      }

      try {
        const buffer = await file.arrayBuffer();
        const wb = XLSX.read(buffer, { type: 'array' });
        let fileHadRows = false;
        for (const sheetName of wb.SheetNames) {
          const ws = wb.Sheets[sheetName];
          const raw: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });
          const rows: ExcelRow[] = raw.map(r => {
            const norm: any = {};
            for (const k of Object.keys(r)) {
              norm[k.toLowerCase().trim().replace(/\s+/g, '_')] = r[k];
            }
            return {
              stock_name: String(norm.stock_name || norm.stockname || norm.name || norm['stock name'] || '').trim(),
              unit: norm.sell_units || norm.unit || norm.units || norm.qty || norm.quantity || '',
              total_amount: norm.sell_amount || norm.total_amount || norm.totalamount || norm.amount || norm.price || '',
              indirect_charges: norm.indirect_charges || norm.indirectcharges || norm.charges || '0',
              date: norm.date || '',
            } as ExcelRow;
          }).filter(r => r.stock_name);
          if (rows.length) {
            allSheets.push({ sheetName, fileName: file.name, fileIndex: fi, rows });
            fileHadRows = true;
          }
        }
        if (!fileHadRows) {
          fileParseWarnings.push(`${file.name}: no rows with a stock_name column found in any sheet.`);
        }
      } catch (err: any) {
        fileParseWarnings.push(`${file.name}: failed to read/parse (${err?.message || 'unknown error'}).`);
      }
    }
    return { sheets: allSheets, warnings: fileParseWarnings };
  };

  // Matches each row's stock_name against the party's currently AVAILABLE
  // (unsold) stock in the chosen category — you can only sell what's held.
  const processSheets = async (
    sheets: SheetData[],
    stockNameList: string[]
  ): Promise<{ [sheetKey: string]: ProcessedExcelRow[] }> => {
    const result: { [sheetKey: string]: ProcessedExcelRow[] } = {};
    const normalizedIndex = buildNormalizedIndex(stockNameList);

    for (const sheet of sheets) {
      const key = `${sheet.fileIndex}__${sheet.fileName}__${sheet.sheetName}`;
      const rows: ProcessedExcelRow[] = [];

      const CHUNK_SIZE = 50;
      for (let i = 0; i < sheet.rows.length; i += CHUNK_SIZE) {
        const chunk = sheet.rows.slice(i, i + CHUNK_SIZE);
        for (const [ri, row] of chunk.entries()) {
          const actualIndex = i + ri;
          const { matched, candidates, status } = fuzzyMatchFast(row.stock_name, normalizedIndex);
          rows.push({
            ...row,
            _rowId: `${key}__${actualIndex}`,
            _sheetKey: key,
            _matchStatus: status,
            _matchedName: matched,
            _candidateMatches: candidates,
            _userChoice: matched,
          } as ProcessedExcelRow);
        }
        await new Promise(resolve => setTimeout(resolve, 0));
      }

      result[key] = rows;
    }
    return result;
  };

  const handleExcelProceed = async () => {
    setExcelSetupError(null);
    if (!excelSetupPartyId) { setExcelSetupError('Select a party.'); return; }
    if (!excelSetupCategory) { setExcelSetupError('Select a category.'); return; }
    if (!excelFiles.length) { setExcelSetupError('Upload at least one Excel or XML file.'); return; }
    if (!excelStocksInCategory.length) {
      setExcelSetupError('This party has no available (unsold) stock in this category to sell.');
      return;
    }

    setExcelParsing(true);
    try {
      const { sheets, warnings } = await parseImportFiles();

      if (!sheets.length) {
        setExcelSetupError(
          warnings.length
            ? warnings.join(' ')
            : 'No valid rows found. Check column names: stock_name, unit/sell_units, total_amount/sell_amount.'
        );
        return;
      }

      const allRowsHaveOwnDate = sheets.every(s => s.rows.every(r => !!r.date));
      if (!allRowsHaveOwnDate && !excelSetupDate) {
        setExcelSetupError('Select a sell date.');
        return;
      }

      const nameList = excelStocksInCategory.map(s => s.stock_name);
      const processed = await processSheets(sheets, nameList);

      for (const key of Object.keys(processed)) {
        processed[key] = processed[key].map(r => ({
          ...r,
          date: r.date || excelSetupDate,
        }));
      }

      setProcessedRows(processed);
      setExcelUploadStep('review');

      if (warnings.length) setExcelSetupError(warnings.join(' '));
    } catch (err: any) {
      setExcelSetupError('Error parsing files: ' + (err?.message || String(err)));
    } finally {
      setExcelParsing(false);
    }
  };

  const updateProcessedRow = (sheetKey: string, rowId: string, patch: Partial<ProcessedExcelRow>) => {
    setProcessedRows(prev => ({
      ...prev,
      [sheetKey]: prev[sheetKey].map(r => (r._rowId === rowId ? { ...r, ...patch } : r)),
    }));
  };

  // A row is "resolved" once it has a confirmed stock match and a date. Units
  // exceeding what's currently available are flagged (not silently clamped)
  // so the user can fix the file or the row before submitting.
  const rowAvailableUnits = (row: ProcessedExcelRow): number | undefined => {
    const finalName = row._userChoice || row._matchedName;
    if (!finalName) return undefined;
    const stock = excelStocksInCategory.find(s => s.stock_name === finalName);
    return stock ? parseFloat(stock.unit) : undefined;
  };

  const allRowsResolved = useMemo(() => {
    for (const sheetRows of Object.values(processedRows)) {
      for (const row of sheetRows) {
        if (!row._userChoice && !row._matchedName) return false;
        if (!row.date) return false;
        const available = rowAvailableUnits(row);
        if (available !== undefined && safeNumber(row.unit) > available) return false;
      }
    }
    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processedRows, excelStocksInCategory]);

  const renderMatchBadge = (status: StockMatchStatus) => {
    if (status === 'matched') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">✓ Matched</span>;
    if (status === 'fuzzy') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">⚠ Fuzzy</span>;
    return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">✗ Not Held</span>;
  };

  // Submitting simply reshapes resolved rows into the same {date, rows[]}
  // "batches" structure the OCR-sell flow already understands, then reuses
  // handleOcrSubmit (which already falls back to `unit`/`total_amount`).
  const handleExcelSubmit = async () => {
    setExcelSubmitLoading(true);
    try {
      const rowsByDate = new Map<string, any[]>();
      for (const sheetRows of Object.values(processedRows)) {
        for (const row of sheetRows) {
          const finalName = row._userChoice || row._matchedName;
          if (!finalName?.trim()) continue;
          const d = row.date || excelSetupDate;
          if (!d) continue;
          if (!rowsByDate.has(d)) rowsByDate.set(d, []);
          rowsByDate.get(d)!.push({
            stock_name: finalName,
            sell_units: row.unit,
            sell_amount: row.total_amount,
            indirect_charges: row.indirect_charges || '0',
          });
        }
      }

      const batches = Array.from(rowsByDate.entries()).map(([date, rows]) => ({ date, rows }));
      if (!batches.length) {
        alert('No resolved rows to submit.');
        return;
      }

      await handleOcrSubmit({ partyId: excelSetupPartyId, category: excelSetupCategory, batches });

      setExcelUploadStep('idle');
      setProcessedRows({});
      setExcelFiles([]);
      setExcelSetupPartyId('');
      setExcelSetupCategory('');
      setExcelSetupDate('');
      alert('Bulk sell submitted successfully!');
    } catch (err: any) {
      alert('Error: ' + (err?.message ?? 'Something went wrong'));
    } finally {
      setExcelSubmitLoading(false);
    }
  };

  // ------------ UI ---------------
  return (
    <div className="w-full min-h-[80vh] flex flex-col items-center justify-center bg-gradient-to-br from-[#f6fcf8] to-[#fff8ef] py-10 transition-colors">
      <div className="w-full max-w-2xl bg-white shadow-2xl rounded-3xl px-6 sm:px-12 py-10 border-4 border-[color:var(--primary)]/10 relative overflow-hidden duo-form-glow">
        <div className="hidden absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-t-3xl animate-fadein" />

        <div className="flex flex-wrap gap-3 mb-4">
          <button
            type="button"
            onClick={() => setShowOcrModal(true)}
            className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
          >
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="currentColor"
                strokeWidth="2"
                fill="#fff"
                fillOpacity=".1"
              />
              <path
                d="M8 2v4M16 2v4M3 10h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle
                cx="12"
                cy="14"
                r="3"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
            Scan Document
          </button>

          {/* Import from Excel or XML — bulk sell */}
          <button
            type="button"
            onClick={() => setExcelUploadStep('setup')}
            className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#0EA5E9] to-[#6366F1] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
          >
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path d="M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 19h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            Import Excel / XML
          </button>
        </div>

        {showOcrModal ? (
          <OcrUploadModal
            partiesList={partiesListWithCategories}
            stocksnames={stocksnames}
            mutualsnames={mutualsnames}
            onSubmit={handleOcrSubmit as any}
            onClose={() => setShowOcrModal(false)}
            apiUrl={process.env.REACT_APP_API_URL || ''}
          />
        ) : null}

        <h2 className="text-center text-4xl md:text-5xl font-extrabold mb-2 tracking-tighter duo-gradient-text drop-shadow-xl select-none">
          Sell Stocks
        </h2>
        <p className="text-center text-gray-600 mb-7 italic bg-[color:var(--primary)]/10 rounded-xl px-3 py-2 text-base shadow border-l-4 border-[color:var(--secondary)]/30 font-medium">
          <span className="inline-block px-2 py-1 bg-gradient-to-tr from-[color:var(--primary)]/10 to-[color:var(--secondary)]/10 rounded">
            Record a new stock sale transaction
          </span>
          <br />
          <span className="font-sans text-sm text-gray-400">
            Select party, then category, then stock.
            <br />
            (Party can be preselected via URL)
          </span>
        </p>
        <form
          onSubmit={handleSellStockSubmit}
          className="grid gap-8 grid-cols-1 md:grid-cols-2 animate-fadeInUp"
          autoComplete="off"
        >
          {/* Party */}
          <div className="col-span-1">
            <label
              htmlFor="partyId"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="party">👤</span> Party Name
            </label>
            <div className="relative">
              <select
                name="partyId"
                id="partyId"
                value={sellStockForm.partyId}
                onChange={handleFormChange}
                className="w-full border-2 border-[color:var(--primary)] bg-[#f8fbf9] rounded-xl px-5 py-3 text-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]/60 font-semibold transition-all"
                required
                style={{ color: 'var(--primary)' }}
              >
                <option value="">Choose Party</option>
                {partiesList.map((p) => (
                  <option key={String(p.id)} value={String(p.id)}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Category */}
          <div className="col-span-1">
            <label
              htmlFor="category"
              className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
            >
              <span role="img" aria-label="category">📂</span> Category
            </label>
            <div className="relative">
              <select
                name="category"
                id="category"
                value={sellStockForm.category}
                onChange={handleFormChange}
                required
                disabled={!sellStockForm.partyId}
                className={`w-full border-2 bg-[#fffcf7] border-[color:var(--secondary)] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-semibold focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all ${
                  !sellStockForm.partyId ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
                }`}
                style={{ color: 'var(--secondary)' }}
              >
                <option value="">Select Category</option>
                {partyCategories.map((cat) => (
                  <option key={String(cat)} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Stock Name — now shows deduplicated list */}
          <div className="col-span-1 md:col-span-2">
            <label
              htmlFor="stockId"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="stock">🏷️</span> Stock Name
            </label>
            <div className="relative">
              <select
                name="stockId"
                id="stockId"
                value={sellStockForm.stockId}
                onChange={handleFormChange}
                required
                disabled={!sellStockForm.category}
                className={`w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-semibold focus:ring-2 focus:ring-[color:var(--primary)]/50 transition-all ${
                  !sellStockForm.category ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
                }`}
                style={{ color: 'var(--primary)' }}
              >
                <option value="">Select Stock</option>
                {stocksInCurrentCategory.map((stock) => (
                  <option key={`${stock.category}__${stock.stock_name}`} value={stock.stock_name}>
                    {stock.stock_name}
                  </option>
                ))}
              </select>
            </div>
            {sellStockForm.category && stocksInCurrentCategory.length === 0 && (
              <p className="text-xs text-center text-red-500 mt-2 font-mono italic">
                No stocks available under this category.
              </p>
            )}
          </div>

          {/* Units To Sell */}
          <div className="col-span-1">
            <label
              htmlFor="sellUnits"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="units">🔢</span> Units To Sell
              {selectedStockObj && (
                <span className="text-xs ml-2 text-gray-400 font-normal">
                  (Available:{' '}
                  <b className="text-[color:var(--secondary)]">{selectedStockObj.unit}</b>)
                </span>
              )}
            </label>
            <div className="relative">
              <input
                type="number"
                name="sellUnits"
                id="sellUnits"
                value={sellStockForm.sellUnits}
                required
                disabled={!sellStockForm.stockId}
                min={0}
                max={selectedStockObj ? selectedStockObj.unit : undefined}
                onChange={handleFormChange}
                className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-medium focus:ring-2 focus:ring-[color:var(--primary)]/40 placeholder-gray-300 transition-all"
                placeholder="How many units to sell"
                style={{ color: 'var(--primary)' }}
                step="any"
                inputMode="decimal"
                pattern="[0-9.]*"
              />
            </div>
            {sellStockForm.sellUnits &&
            selectedStockObj &&
            parseFloat(sellStockForm.sellUnits) > parseFloat(selectedStockObj.unit) ? (
              <span className="text-xs text-red-600 font-semibold px-2 py-1 inline-block bg-[#ffedf1] rounded mt-1">
                Not enough units available!
              </span>
            ) : null}
          </div>

          {/* Sell Amount */}
          <div className="col-span-1">
            <label
              htmlFor="sellAmount"
              className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
            >
              <span role="img" aria-label="amount">💰</span> Sell Amount
              <span className="text-xs bg-[#fff8ef] text-[color:var(--primary)] px-2 py-1 rounded font-mono ml-2">
                (Auto: {(autoAmount || 0).toFixed(2)}{' '}
                {sellStockForm.sellUnits ? 'calculated' : ''})
              </span>
            </label>
            <div className="relative">
              <input
                type="number"
                name="sellAmount"
                id="sellAmount"
                placeholder={`Auto: ${(autoAmount || 0).toFixed(2)}`}
                value={sellStockForm.sellAmount}
                min={0}
                step="any"
                onChange={handleFormChange}
                required
                disabled={!sellStockForm.stockId}
                className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all placeholder-gray-400"
                style={{ color: 'var(--secondary)' }}
                inputMode="decimal"
                pattern="[0-9]*"
              />
            </div>
            <span className="block text-xs text-gray-400 mt-1 font-mono ml-2">
              Leave blank for auto-calculated. You can adjust if desired.
            </span>
          </div>

          {/* Indirect Charges */}
          <div className="col-span-1">
            <label
              htmlFor="indirectCharges"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="fees">💸</span> Indirect Charges
            </label>
            <div className="relative">
              <input
                type="number"
                name="indirectCharges"
                id="indirectCharges"
                placeholder="Enter indirect charges (if any)"
                value={sellStockForm.indirectCharges}
                min={0}
                step="any"
                onChange={handleFormChange}
                disabled={!sellStockForm.stockId}
                className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-normal focus:ring-2 focus:ring-[color:var(--primary)]/60 placeholder-gray-300 transition-all"
                style={{ color: 'var(--primary)' }}
              />
            </div>
          </div>

          {/* Date */}
          <div className="col-span-1">
            <label
              htmlFor="date"
              className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
            >
              <span role="img" aria-label="date">📅</span> Date
            </label>
            <div className="relative">
              <input
                type="date"
                name="date"
                id="date"
                value={sellStockForm.date}
                onChange={handleFormChange}
                required
                className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/40 transition-all"
                disabled={!sellStockForm.stockId}
                style={{ color: 'var(--secondary)' }}
              />
            </div>
          </div>

          {/* Submit */}
          <div className="col-span-1 md:col-span-2 flex flex-col md:flex-row-reverse justify-between items-center gap-3 pt-2">
            <button
              type="submit"
              disabled={loading}
              className="px-10 py-3 rounded-full bg-gradient-to-r from-[color:var(--primary)] to-[color:var(--secondary)] text-white font-extrabold text-2xl transform hover:scale-105 active:scale-100 transition-all focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/50 disabled:opacity-60 flex items-center gap-2 border-b-4 border-[color:var(--secondary)]/50"
              style={{
                boxShadow: '0 8px 48px 3px #94efd990, 0 3px 15px -2px #f8bb498f',
              }}
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin mr-2 h-6 w-6 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8z"
                    />
                  </svg>
                  Selling...
                </>
              ) : (
                <>
                  <span role="img" aria-label="sell">💸</span> Sell Stock
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          EXCEL / XML BULK-SELL MODAL — STEP: SETUP
      ══════════════════════════════════════════════════════════════════════ */}
      {excelUploadStep === 'setup' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
            <div className="bg-gradient-to-r from-[#0EA5E9] to-[#6366F1] px-6 py-5">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-bold text-white">Bulk Sell — Upload Excel or XML</h2>
                  <p className="text-indigo-200 text-sm mt-0.5">Step 1 of 2 — Configure import settings</p>
                </div>
                <button onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); setExcelSetupError(null); }} className="text-white/70 hover:text-white text-2xl">×</button>
              </div>
            </div>

            <div className="p-6 flex flex-col gap-4">
              {/* Party */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Party Name <span className="text-red-500">*</span></label>
                <select value={excelSetupPartyId} onChange={e => { setExcelSetupPartyId(e.target.value); setExcelSetupCategory(''); }} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400">
                  <option value="">Choose Party</option>
                  {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
                </select>
              </div>
              {/* Category */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Category <span className="text-red-500">*</span></label>
                <select value={excelSetupCategory} onChange={e => setExcelSetupCategory(e.target.value)} disabled={!excelSetupPartyId} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400 disabled:bg-gray-100">
                  <option value="">Select Category</option>
                  {excelSetupCategories.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                {excelSetupCategory && (
                  <p className="text-xs text-gray-400 mt-1">
                    {excelStocksInCategory.length} stock(s) currently held and available to sell in this category.
                  </p>
                )}
              </div>
              {/* Date — hidden/optional when an XML file is present, since each
                  transaction in the XML already carries its own date. */}
              {!hasXmlFile && (
                <div>
                  <label className="text-sm font-semibold text-gray-700 block mb-1">Sell Date <span className="text-red-500">*</span></label>
                  <input type="date" value={excelSetupDate} onChange={e => setExcelSetupDate(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400" />
                </div>
              )}
              {hasXmlFile && (
                <div className="bg-indigo-50 border border-indigo-100 rounded-lg px-3 py-2 text-xs text-indigo-700">
                  📅 Dates will be read automatically from the XML file — no need to pick one here.
                </div>
              )}

              {/* File Upload */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-2">Excel or XML Files <span className="text-red-500">*</span></label>
                <div
                  className="border-2 border-dashed border-indigo-200 rounded-xl p-6 text-center cursor-pointer hover:border-indigo-400 hover:bg-indigo-50/50 transition"
                  onClick={() => excelFileInputRef.current?.click()}
                >
                  <div className="text-3xl mb-2">📊</div>
                  <p className="text-sm text-gray-600 font-medium">Click to browse or drop files here</p>
                  <p className="text-xs text-gray-400 mt-1">Supports .xlsx, .xls, and .xml — multiple files allowed, all sheets/rows imported</p>
                  <p className="text-xs text-indigo-500 mt-1 font-medium">Excel columns / XML fields: <code className="bg-indigo-50 px-1 rounded">stock_name</code>, <code className="bg-indigo-50 px-1 rounded">sell_units</code>/<code className="bg-indigo-50 px-1 rounded">unit</code>, <code className="bg-indigo-50 px-1 rounded">sell_amount</code>/<code className="bg-indigo-50 px-1 rounded">total_amount</code></p>
                </div>
                <input ref={excelFileInputRef} type="file" accept=".xlsx,.xls,.xml" multiple className="hidden" onChange={handleExcelFilesChange} />
                {excelFiles.length > 0 && (
                  <div className="mt-3 flex flex-col gap-1.5">
                    {excelFiles.map((f, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
                        <div className="flex items-center gap-2">
                          <span className="text-green-500">{f.name.toLowerCase().endsWith('.xml') ? '🗂️' : '📄'}</span>
                          <span className="text-sm text-gray-700 font-medium">{f.name}</span>
                          <span className="text-xs text-gray-400">({(f.size / 1024).toFixed(1)} KB)</span>
                        </div>
                        <button type="button" onClick={() => removeExcelFile(i)} className="text-red-400 hover:text-red-600 text-lg leading-none">×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {excelSetupError && (
                <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-xs text-red-700 whitespace-pre-line">
                  ⚠ {excelSetupError}
                </div>
              )}

              <div className="flex gap-3 mt-2">
                <button
                  type="button"
                  onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); setExcelSetupError(null); }}
                  disabled={excelParsing}
                  className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2.5 font-medium hover:bg-gray-50 transition disabled:opacity-50"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleExcelProceed}
                  disabled={excelParsing}
                  className="flex-1 bg-gradient-to-r from-[#0EA5E9] to-[#6366F1] text-white rounded-lg py-2.5 font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {excelParsing ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                      </svg>
                      Processing rows…
                    </span>
                  ) : 'Preview & Review →'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════════
          EXCEL / XML BULK-SELL MODAL — STEP: REVIEW
      ══════════════════════════════════════════════════════════════════════ */}
      {excelUploadStep === 'review' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl mx-4 flex flex-col" style={{ maxHeight: '90vh' }}>
            <div className="bg-gradient-to-r from-[#0EA5E9] to-[#6366F1] px-6 py-5 rounded-t-2xl flex-shrink-0">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-bold text-white">Review Bulk Sell Data</h2>
                  <p className="text-indigo-200 text-sm mt-0.5">Step 2 of 2 — Verify stock matches, quantities, and dates</p>
                </div>
                <button onClick={() => setExcelUploadStep('setup')} className="text-white/70 hover:text-white text-2xl">×</button>
              </div>
              <div className="flex gap-4 mt-3">
                {(() => {
                  let matched = 0, fuzzy = 0, unmatched = 0;
                  Object.values(processedRows).flat().forEach(r => {
                    if (r._matchStatus === 'matched') matched++;
                    else if (r._matchStatus === 'fuzzy') fuzzy++;
                    else unmatched++;
                  });
                  const total = matched + fuzzy + unmatched;
                  return (
                    <>
                      <div className="bg-white/20 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{total}</span> total rows</div>
                      <div className="bg-green-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{matched}</span> matched</div>
                      {fuzzy > 0 && <div className="bg-yellow-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{fuzzy}</span> fuzzy</div>}
                      {unmatched > 0 && <div className="bg-red-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{unmatched}</span> not held</div>}
                    </>
                  );
                })()}
              </div>
            </div>

            <div className="overflow-y-auto flex-1 p-6">
              {Object.entries(processedRows).map(([sheetKey, rows]) => {
                const parts = sheetKey.split('__');
                const fileName = parts[1], sheetName = parts[2];
                return (
                  <div key={sheetKey} className="mb-8">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="bg-indigo-100 text-indigo-700 rounded-lg px-3 py-1 text-sm font-semibold">
                        {fileName?.toLowerCase().endsWith('.xml') ? '🗂️' : '📄'} {fileName}
                      </div>
                      <div className="bg-gray-100 text-gray-600 rounded-lg px-3 py-1 text-sm">Sheet: {sheetName}</div>
                      <div className="text-xs text-gray-400">{rows.length} rows</div>
                    </div>
                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">#</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Source Stock Name</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Status</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Match In Holdings</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Date</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Sell Units</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Sell Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((row, ri) => {
                            const available = rowAvailableUnits(row);
                            const exceeds = available !== undefined && safeNumber(row.unit) > available;
                            return (
                              <tr key={row._rowId} className={`border-t border-gray-100 ${row._matchStatus === 'matched' ? 'bg-green-50/30' : row._matchStatus === 'fuzzy' ? 'bg-yellow-50/30' : 'bg-red-50/30'}`}>
                                <td className="px-4 py-3 text-gray-500">{ri + 1}</td>
                                <td className="px-4 py-3 font-medium text-gray-800">
                                  <input
                                    type="text"
                                    value={row.stock_name}
                                    onChange={e => updateProcessedRow(sheetKey, row._rowId, { stock_name: e.target.value })}
                                    className="border border-gray-200 rounded px-2 py-1 text-xs w-36 focus:outline-none focus:border-indigo-400 bg-transparent"
                                  />
                                </td>
                                <td className="px-4 py-3">{renderMatchBadge(row._matchStatus)}</td>
                                <td className="px-4 py-3">
                                  {row._matchStatus === 'matched'
                                    ? <span className="text-green-700 font-medium">{row._matchedName}</span>
                                    : <select value={row._userChoice || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _userChoice: e.target.value })} className="border border-gray-300 rounded-lg px-2 py-1 text-xs w-44 focus:outline-none focus:border-indigo-400">
                                        <option value="">— select match —</option>
                                        {(row._candidateMatches?.length ? row._candidateMatches : excelStocksInCategory.map(s => s.stock_name)).map(c => <option key={c} value={c}>{c}</option>)}
                                      </select>
                                  }
                                  {available !== undefined && (
                                    <div className="text-[10px] text-gray-400 mt-0.5">Available: {available}</div>
                                  )}
                                </td>
                                <td className="px-4 py-3">
                                  <input
                                    type="date"
                                    value={row.date || ''}
                                    onChange={e => updateProcessedRow(sheetKey, row._rowId, { date: e.target.value })}
                                    className="border border-gray-200 rounded px-2 py-1 text-xs w-36 focus:outline-none focus:border-indigo-400"
                                  />
                                </td>
                                <td className="px-4 py-3">
                                  <input
                                    type="number"
                                    value={row.unit}
                                    onChange={e => updateProcessedRow(sheetKey, row._rowId, { unit: e.target.value })}
                                    className={`border rounded px-2 py-1 text-xs w-20 focus:outline-none ${exceeds ? 'border-red-400 focus:border-red-500' : 'border-gray-200 focus:border-indigo-400'}`}
                                  />
                                  {exceeds && <div className="text-[10px] text-red-500 mt-0.5">Exceeds available!</div>}
                                </td>
                                <td className="px-4 py-3">
                                  <input
                                    type="number"
                                    value={row.total_amount}
                                    placeholder="Auto if blank"
                                    onChange={e => updateProcessedRow(sheetKey, row._rowId, { total_amount: e.target.value })}
                                    className="border border-gray-200 rounded px-2 py-1 text-xs w-24 focus:outline-none focus:border-indigo-400"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex-shrink-0 flex items-center justify-between">
              <div className="text-sm text-gray-500">
                {!allRowsResolved
                  ? <span className="text-amber-600 font-medium">⚠ Some rows need attention (select a match, set a date, or fix quantity)</span>
                  : <span className="text-green-600 font-medium">✓ All rows resolved — ready to submit</span>
                }
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => setExcelUploadStep('setup')} className="border border-gray-300 text-gray-700 rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition">← Back</button>
                <button
                  type="button"
                  disabled={!allRowsResolved || excelSubmitLoading}
                  onClick={handleExcelSubmit}
                  className="bg-gradient-to-r from-[#1CAC70] to-[#059669] text-white rounded-lg px-6 py-2 text-sm font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {excelSubmitLoading ? 'Submitting...' : `Sell ${Object.values(processedRows).flat().length} Rows`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        :root {
          --primary: ${PRIMARY};
          --secondary: ${SECONDARY};
        }
        .duo-gradient-text {
          background: linear-gradient(90deg, var(--primary), var(--secondary) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        @media (max-width: 600px){
          .duo-form-glow:before, .duo-form-glow:after{display:none;}
        }
        .animate-fadein{
          animation: fadeInLeft 0.7s cubic-bezier(.29,.31,.41,1.41);
        }
        @keyframes fadeInLeft{
          0%{ opacity:0; transform:translateX(-100%);}
          80%{ opacity:0.2;}
          100%{ opacity:1; transform: translateX(0);}
        }
        .animate-fadeInUp {
          animation: fadeInUp 1.0s cubic-bezier(.38,.33,.52,1.42);
        }
        @keyframes fadeInUp {
          0% {opacity: 0; transform: translateY(40px);}
          100% {opacity: 1; transform: translateY(0);}
        }
      `}</style>
    </div>
  );
};

export default SellStocksPage;